import React, { useState, useEffect, useCallback } from "react";
import Styles from "./TermsCondition.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import "@wojtekmaj/react-timerange-picker/dist/TimeRangePicker.css";
import "react-clock/dist/Clock.css";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import { toast } from "react-toastify";
import { formatDate, formatSlotTime } from "../../../../../helpers/dateFormat";
import ConfirmationModal from "../../../../../commons/ConfirmationModal/ConfirmationModal";
import DateInput from "../../../../../commons/Inputs/DateInputBailateral/DateInput";
import TimeInput from "../../../../../commons/Inputs/TimeInputBailateral/TimeInput";
import { IconButton, Tooltip } from "@mui/material";
import { ReactComponent as InfoIcon } from "../../../../../assets/images/info.svg";

import {
  fetchActiveConnection,
  fetchLedgerBids,
  fetchMainScreenActiveConnection,
  fetchSelfCapacity,
  fetchSelfCapacityById,
} from "../../../../../Redux/Slices/CapacitySlice";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../../commons/Toast/ErrorMessage";
import { useNavigate } from "react-router-dom";
import { USER_TYPES } from "../../../../Bilateral/LedgerPageDashboardActive/LedgerPageDashboardActive";
import {
  handleAcceptT_C,
  handleInitEditT_C,
  handleRejectAllT_C,
} from "../../../../../Services/BuySell/Creation";
import { AntSwitch } from "../../../../Bilateral/LedgerViewContent/LegerViewType";
import ChargeSelection from "../ChargeSelection/ChargeSelection";
import {
  bilateralContractCreate,
  updateContract,
} from "../../../../../Services/Payments/PaymentApi";
import SelectInput from "../../../../../commons/Inputs/Select/SelectInput";
import { EnergyRateList } from "../../../../Modals/ConGen/ConGenListingModal";

const TermsCondition = ({
  open,
  handleClose,
  isEditTerms = false,
  listingId,
  type,
}) => {
  const selfEntityId = useSelector(
    (state) =>
      state?.persistedReducer?.user?.activeGeneratorId ||
      state?.persistedReducer?.user?.activeConsumerId,
  );
  const activeRole = useSelector((state) => state?.persistedReducer?.userType);

  const [uniqueSelfReq, setUniqueSelfReq] = useState([]);
  const [selectedSelfReq, setSelectedSelfReq] = useState(null);
  const [finalValues, setFinalValues] = useState({});
  const [sharedPaymentValues, setSharedPaymentValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [conformOpen, setConformOpen] = useState(false);
  const [dataWithIndex, setDataWithIndex] = useState([]);
  const activeConnectionData = useSelector(
    (state) => state?.CapacitySlice?.activeConnection,
  );
  const { listingType } = useSelector(
    (state) => state?.CapacitySlice?.activeMain,
  );
  const [collapsedCompanies, setCollapsedCompanies] = useState(new Set());
  const [collapsedRequisitions, setCollapsedRequisitions] = useState(new Set());
  const [wholeData, setWholeData] = useState([]);
  console.log("🚀 ~ TermsCondition ~ wholeData:", wholeData);
  const [rejectAllTermsConfirm, setRejectAllTermsConfirm] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [selectedBids, setSelectedBids] = useState([]);
  const mainScreenMatchData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection,
  );
  const selfCapacityById = useSelector(
    (state) => state?.CapacitySlice?.activeMain,
  );

  const [chargeModal, setChargeModal] = useState(false);
  const [chargeDetails, setChargeDetails] = useState();
  const [rejectContract, setRejectContract] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector(
    (state) => state.persistedReducer.user?.activeRole,
  )?.toLowerCase();

  const HighlightIfDifferent = ({ value, compareWith }) => {
    const isDifferent = value !== compareWith;
    return isDifferent;
  };

  const consumerList = useSelector(
    (state) => state?.CapacitySlice?.fetchSideBarList?.consumers,
  );

  const generatorList = useSelector(
    (state) => state?.CapacitySlice?.fetchSideBarList?.generators,
  );

  useEffect(() => {
    dispatch(fetchMainScreenActiveConnection({ capId: listingId }));
  }, [dispatch, listingId]);

  const consumerGeneratorId = useSelector((state) => {
    const activeMain =
      state?.persistedReducer?.user?.activeGeneratorId ||
      state?.persistedReducer?.user?.activeConsumerId;
    return activeMain;
  });

  function getMaxQuantity() {
    if (activeRole === "CONSUMER") {
      const consumer = consumerList?.find(
        (c) => c.consumerId === consumerGeneratorId,
      );
      return consumer?.maxCapDrawl;
    }
    if (activeRole === "GENERATOR") {
      const generator = generatorList?.find(
        (g) => g.generatorId === consumerGeneratorId,
      );

      return generator?.maxInjCap;
    }
  }

  useEffect(() => {
    if (!activeConnectionData || !Array.isArray(activeConnectionData)) return;

    const cloned = JSON.parse(JSON.stringify(activeConnectionData));
    const isAcceptFlow = type === "accept";

    cloned?.forEach((item) => {
      if (!item.matches) return;

      item.matches = item.matches
        .map((match) => {
          const partyKey = match.generators ? "generators" : "consumers";
          if (!match[partyKey]) return null;

          match[partyKey] = match[partyKey]
            .map((party) => {
              // Filter parties based on flow
              if (isEditTerms) {
                const isInitiated = party.status === "TERMS_INITIATED";
                const initiatedByMe =
                  party.initiatorType &&
                  party.initiatorType.toLowerCase() === user;
                if (!(isInitiated && initiatedByMe)) return null;
              } else if (!isEditTerms) {
                if (isAcceptFlow) {
                  const isInitiated = party.status === "TERMS_INITIATED";
                  const initiatedByCounterparty =
                    party.initiatorType &&
                    party.initiatorType.toLowerCase() !== user;
                  if (!(isInitiated && initiatedByCounterparty)) return null;
                } else {
                  const isApproved = party.status === "APPROVED";
                  const isCounterpartyInitiated =
                    party.status === "TERMS_INITIATED" &&
                    party.initiatorType &&
                    party.initiatorType.toLowerCase() !== user;
                  if (!isApproved && !isCounterpartyInitiated) return null;
                }
              }

              const slots = party.matchSlots || [];
              const filteredSlots = isAcceptFlow
                ? isEditTerms
                  ? slots.filter((slot) => slot.finalizedConnectionValues)
                  : slots.filter((slot) => slot.finalizedConnectionValues) // Filter only slots with finalizedConnectionValues
                : slots;

              if (!filteredSlots.length) return null;
              return { ...party, matchSlots: filteredSlots };
            })
            .filter(Boolean);

          return match[partyKey].length > 0 ? match : null;
        })
        .filter(Boolean);
    });

    const filtered = cloned.filter(
      (item) => item.matches && item.matches.length > 0,
    );
    setWholeData(filtered);
  }, [activeConnectionData, type, isEditTerms, user]);

  useEffect(() => {
    if (listingId) {
      dispatch(
        fetchActiveConnection({
          curr: 0,
          capId: listingId,
          isTermsAccepted: null,
        }),
      );
    }
  }, [dispatch, listingId]);

  const getFinalizedId = useCallback(() => {
    if (isEditTerms && mainScreenMatchData) {
      let ids = [];
      let accessKey = user === "consumer" ? "generatorSlot" : "consumerSlot";
      for (let i = 0; i < mainScreenMatchData.length; i++) {
        for (
          let j = 0;
          j < mainScreenMatchData[i].bilateralConnections.length;
          j++
        ) {
          ids.push(
            mainScreenMatchData[i].bilateralConnections[j][accessKey].id,
          );
        }
      }

      return ids;
    }
  }, [isEditTerms, mainScreenMatchData, user]);

  const getEditData = useCallback(() => {
    if (!isEditTerms || getFinalizedId().length === 0) return [];

    const accessKey = user === "consumer" ? "generators" : "consumers";
    const finalizedIds = getFinalizedId();
    const copiedWholeData = JSON.parse(JSON.stringify(wholeData));

    const cleanedData = copiedWholeData
      .map((item) => {
        const cleanedMatches = item.matches
          .map((match) => {
            const cleanedEntities = match[accessKey]
              .map((entity) => {
                // Filter matchSlots: include only if id is in finalizedIds AND status is not ACCEPTED
                const cleanedSlots = entity.matchSlots.filter(
                  (slot) =>
                    finalizedIds.includes(slot.id) &&
                    slot.finalizedConnectionValues?.status !== "ACCEPTED",
                );

                return cleanedSlots.length > 0
                  ? { ...entity, matchSlots: cleanedSlots }
                  : null;
              })
              .filter(Boolean);

            return cleanedEntities.length > 0
              ? { ...match, [accessKey]: cleanedEntities }
              : null;
          })
          .filter(Boolean);

        return cleanedMatches.length > 0
          ? { ...item, matches: cleanedMatches }
          : null;
      })
      .filter(Boolean);
    return cleanedData;
  }, [getFinalizedId, isEditTerms, user, wholeData]);

  let finalData = useCallback(() => {
    return isEditTerms ? getEditData() : wholeData;
  }, [wholeData, getEditData, isEditTerms]);

  const useTransformToPayload = () => {
    // Memoize normalizeTime for clarity
    const normalizeTime = useCallback(
      (time) => (time === "24:00" ? "23:59" : time),
      [],
    );

    // Memoized transformToPayload
    return useCallback(
      (finalValues, user, wholeData, listingId, selectedBids) => {
        const bilateralConnections = [];
        const paymentDetailsMap = new Map();
        const processedSlots = new Set();
        const selectedBidIds = new Set(); // Track which bidIds have selected slots

        // Memoized slot selection logic
        const isSlotSelected = (
          selfSlotId,
          matchSlotId,
          bidId,
          companyName,
          matchIndex,
        ) => {
          return selectedBids.some((bid) => {
            const uniqueId1 = `${selfSlotId}-${matchSlotId}`;
            const uniqueId2 = `${selfSlotId}-${matchSlotId}-${matchIndex}`;
            const stableMatch =
              bid.selfRequisitionIndex == selfSlotId &&
              bid.consumerGeneratorBidId == bidId &&
              bid.company === companyName;
            return (
              bid.uniqueId === uniqueId1 ||
              bid.uniqueId === uniqueId2 ||
              stableMatch
            );
          });
        };

        Object.keys(finalValues).forEach((selfReqIndex) => {
          const requisitionData = finalValues[selfReqIndex];

          Object.keys(requisitionData).forEach((bidId) => {
            const counterpartyData = requisitionData[bidId];
            const matchData = wholeData
              ?.find((item) =>
                item.matches?.some(
                  (match) => match.selfSlot.id == selfReqIndex,
                ),
              )
              ?.matches?.find((match) => match.selfSlot.id == selfReqIndex);

            if (!matchData) return;

            let counterparty;
            if (user === USER_TYPES.CONSUMER) {
              counterparty = matchData?.generators?.find(
                (gen) => gen.bidId == bidId,
              );
            } else if (user === USER_TYPES.GENERATOR) {
              counterparty = matchData?.consumers?.find(
                (con) => con.bidId == bidId,
              );
            }

            // **NEW CHECK**: Skip if counterparty has initiatorType
            if (!counterparty || counterparty.initiatorType) {
              return;
            }

            if (matchData && counterparty) {
              let reqCounter = 1;
              let hasSelectedSlot = false; // Track if this bidId has any selected slot

              counterparty.matchSlots?.forEach((matchSlot, slotIndex) => {
                if (matchSlot.finalizedConnectionValues) {
                  const sourceData =
                    matchSlot.finalizedConnectionValues || matchSlot;
                  const consumerSlotId =
                    user === USER_TYPES.CONSUMER
                      ? matchData.selfSlot.id
                      : matchSlot.id;
                  const generatorSlotId =
                    user === USER_TYPES.CONSUMER
                      ? matchSlot.id
                      : matchData.selfSlot.id;

                  const connection = {
                    id: sourceData.id,
                    consumerGeneratorBidId: parseInt(bidId),
                    consumerSlotId,
                    generatorSlotId,
                    dateStartAt:
                      counterpartyData[`req${reqCounter}_startDate`] ||
                      sourceData.dateStartAt,
                    dateEndAt:
                      counterpartyData[`req${reqCounter}_endDate`] ||
                      sourceData.dateEndAt,
                    slotStartAt: normalizeTime(
                      counterpartyData[`req${reqCounter}_startTime`] ||
                        sourceData.slotStartAt,
                    ),
                    slotEndAt: normalizeTime(
                      counterpartyData[`req${reqCounter}_endTime`] ||
                        sourceData.slotEndAt,
                    ),
                    quantity: parseFloat(
                      counterpartyData[`req${reqCounter}_quantity`] ||
                        sourceData.quantity ||
                        0,
                    ),
                    energyRateType:
                      counterpartyData[`req${reqCounter}_energyRateStr`] ||
                      sourceData.energyRateType ||
                      "",
                    amount:
                      (isNaN(counterpartyData[`req${reqCounter}_energyRate`])
                        ? counterpartyData[
                            `req${reqCounter}_energyRate`
                          ]?.split("+")?.[1] !== undefined
                          ? Number(
                              counterpartyData[
                                `req${reqCounter}_energyRate`
                              ]?.split("+")?.[1],
                            )
                          : Number(
                              counterpartyData[
                                `req${reqCounter}_energyRate`
                              ]?.split("-")?.[1],
                            )
                        : Number(
                            counterpartyData[`req${reqCounter}_energyRate`],
                          )) ??
                      matchSlot?.landingCost ??
                      matchSlot?.sellingCost ??
                      0,
                    purchaseEnergy:
                      Number(counterpartyData[`req${reqCounter}_quantity`]) ||
                      sourceData.quantity ||
                      0,
                  };

                  bilateralConnections.push(connection);
                  hasSelectedSlot = true; // Mark that this bidId has a selected slot
                  reqCounter++;
                } else {
                  const consumerSlotId =
                    user === USER_TYPES.CONSUMER
                      ? matchData.selfSlot.id
                      : matchSlot.id;
                  const generatorSlotId =
                    user === USER_TYPES.CONSUMER
                      ? matchSlot.id
                      : matchData.selfSlot.id;

                  const matchIndex =
                    wholeData?.findIndex((item) =>
                      item.matches?.some((m) => m.selfSlot.id == selfReqIndex),
                    ) || 0;

                  if (
                    !isSlotSelected(
                      matchData.selfSlot.id,
                      matchSlot.id,
                      bidId,
                      counterparty.companyName,
                      matchIndex,
                    )
                  ) {
                    return;
                  }

                  const slotKey = `${consumerSlotId}-${generatorSlotId}-${bidId}`;
                  if (processedSlots.has(slotKey)) {
                    return;
                  }
                  processedSlots.add(slotKey);

                  const connection = {
                    consumerGeneratorBidId: parseInt(bidId),
                    consumerSlotId,
                    generatorSlotId,
                    dateStartAt:
                      counterpartyData[`req${reqCounter}_startDate`] ||
                      matchSlot.dateStartAt,
                    dateEndAt:
                      counterpartyData[`req${reqCounter}_endDate`] ||
                      matchSlot.dateEndAt,
                    slotStartAt: normalizeTime(
                      counterpartyData[`req${reqCounter}_startTime`] ||
                        matchSlot.slotStartAt,
                    ),
                    slotEndAt: normalizeTime(
                      counterpartyData[`req${reqCounter}_endTime`] ||
                        matchSlot.slotEndAt,
                    ),
                    quantity: parseFloat(
                      counterpartyData[`req${reqCounter}_quantity`] || 0,
                    ),
                    amount:
                      (isNaN(counterpartyData[`req${reqCounter}_energyRate`])
                        ? counterpartyData[
                            `req${reqCounter}_energyRate`
                          ]?.split("+")?.[1] !== undefined
                          ? Number(
                              counterpartyData[
                                `req${reqCounter}_energyRate`
                              ]?.split("+")?.[1],
                            )
                          : Number(
                              counterpartyData[
                                `req${reqCounter}_energyRate`
                              ]?.split("-")?.[1],
                            )
                        : Number(
                            counterpartyData[`req${reqCounter}_energyRate`],
                          )) ??
                      matchSlot?.landingCost ??
                      matchSlot?.sellingCost ??
                      0,
                    purchaseEnergy:
                      matchSlot?.purchaseEnergy || matchSlot?.sellEnergy || 0,
                    energyRateType:
                      counterpartyData[`req${reqCounter}_energyRateStr`] || "",
                  };
                  bilateralConnections.push(connection);
                  hasSelectedSlot = true; // Mark that this bidId has a selected slot
                  reqCounter++;
                }
              });

              // Only add payment details if this bidId has at least one selected slot
              if (hasSelectedSlot && !paymentDetailsMap.has(bidId)) {
                paymentDetailsMap.set(bidId, {
                  consumerGeneratorBidId: parseInt(bidId),
                  paymentSecurity: parseFloat(
                    counterpartyData.paymentSecurity || 0,
                  ),
                  initialMargin: parseFloat(
                    counterpartyData.initialMargin || 0,
                  ),
                  emd: parseFloat(counterpartyData.emd || 0),
                });
              }
            }
          });
        });

        return {
          userType: user,
          bilateralConnections,
          paymentDetails: Array.from(paymentDetailsMap.values()),
          capacityId: listingId,
        };
      },
      [normalizeTime],
    );
  };

  const transformToPayload = useTransformToPayload();

  const checkPayloadType = useCallback(
    (finalValues) => {
      if (!wholeData[0]?.matches || !Array.isArray(wholeData[0].matches)) {
        return { type: "finalize", hasFinalize: false, hasAccept: false };
      }

      const matches = wholeData[0].matches;
      const counterpartyKey =
        user === USER_TYPES.GENERATOR ? "consumers" : "generators";

      let hasWithInitiatorType = false;
      let hasWithoutInitiatorType = false;

      matches.forEach((match, matchIndex) => {
        const counterparties = match[counterpartyKey] || [];

        counterparties.forEach((counterparty) => {
          // Check if ANY slot from this counterparty is selected
          const hasSelectedSlot = counterparty.matchSlots?.some((slot) =>
            selectedBids.some(
              (bid) =>
                bid.id === slot.id &&
                bid.consumerGeneratorBidId == counterparty.bidId &&
                bid.matchIndex === matchIndex,
            ),
          );

          // Skip counterparty if no slots are selected
          if (!hasSelectedSlot) {
            return;
          }

          if (counterparty.initiatorType) {
            hasWithInitiatorType = true;
          } else {
            hasWithoutInitiatorType = true;
          }
        });
      });

      // Determine the type based on what we found
      if (hasWithInitiatorType && hasWithoutInitiatorType) {
        return { type: "both", hasFinalize: true, hasAccept: true };
      } else if (hasWithInitiatorType) {
        return { type: "accept", hasFinalize: false, hasAccept: true };
      } else if (hasWithoutInitiatorType) {
        return { type: "finalize", hasFinalize: true, hasAccept: false };
      } else {
        return { type: "finalize", hasFinalize: false, hasAccept: false };
      }
    },
    [wholeData, user, selectedBids], // Added selectedBids to dependencies
  );
  const getAllFinalizedConnectionIds = React.useCallback(
    (onGoingData, finalValues) => {
      const ids = [];
      if (!onGoingData?.matches) return ids;

      // Helper function to check if a slot is selected (same as in transformToPayload)
      const isSlotSelected = (
        selfSlotId,
        matchSlotId,
        bidId,
        companyName,
        matchIndex,
      ) => {
        return selectedBids.some((bid) => {
          // Match by uniqueId (format: selfSlotId-matchSlotId or selfSlotId-matchSlotId-matchIndex)
          const uniqueId1 = `${selfSlotId}-${matchSlotId}`;
          const uniqueId2 = `${selfSlotId}-${matchSlotId}-${matchIndex}`;

          // Also match by stable properties (in case IDs changed)
          const stableMatch =
            bid.selfRequisitionIndex == selfSlotId &&
            bid.consumerGeneratorBidId == bidId &&
            bid.company === companyName;

          return (
            bid.uniqueId === uniqueId1 ||
            bid.uniqueId === uniqueId2 ||
            stableMatch
          );
        });
      };

      const processSlot = (
        slot,
        selfSlotId,
        bidId,
        companyName,
        matchIndex,
      ) => {
        if (
          slot.finalizedConnectionValues &&
          slot.finalizedConnectionValues.id !== undefined
        ) {
          // Check if this slot is selected using flexible matching
          if (
            isSlotSelected(selfSlotId, slot.id, bidId, companyName, matchIndex)
          ) {
            ids.push(slot.finalizedConnectionValues.id);
          }
        }
      };

      if (!finalValues) {
        // Process all slots
        onGoingData.matches.forEach((match, matchIndex) => {
          [...(match.consumers || []), ...(match.generators || [])].forEach(
            (item) => {
              (item.matchSlots || []).forEach((slot) => {
                processSlot(
                  slot,
                  match.selfSlot.id,
                  item.bidId,
                  item.companyName,
                  matchIndex,
                );
              });
            },
          );
        });
      } else {
        // Process only selected slots
        onGoingData.matches.forEach((match, matchIndex) => {
          [...(match.consumers || []), ...(match.generators || [])].forEach(
            (item) => {
              (item.matchSlots || []).forEach((slot) => {
                processSlot(
                  slot,
                  match.selfSlot.id,
                  item.bidId,
                  item.companyName,
                  matchIndex,
                );
              });
            },
          );
        });
      }

      return ids;
    },
    [selectedBids],
  );

  const handleInitPayment = useCallback(
    async (contracts, allCharges) => {
      if (!contracts || contracts.length === 0) return;

      const apiPromises = [];

      const isConsumer = activeRole === "CONSUMER";

      const selfId = isConsumer
        ? contracts[0]?.capacityConsumer?.consumerId
        : contracts[0]?.capacityGenerator?.generatorId;

      const selfChargesList = allCharges.filter((charge) =>
        isConsumer
          ? charge.consumerId === selfId
          : charge.generatorId === selfId,
      );

      contracts.forEach((contract) => {
        const currentContractId = contract.id;

        // Identify the Counterparty ID for THIS specific contract
        const counterId = isConsumer
          ? contract.capacityGenerator?.generatorId
          : contract.capacityConsumer?.consumerId;

        // Filter charges that belong specifically to this Counterparty
        const counterChargesList = allCharges.filter((charge) =>
          isConsumer
            ? charge.generatorId === counterId
            : charge.consumerId === counterId,
        );

        if (selfChargesList.length > 0) {
          const selfPayload = selfChargesList.map((charge) => ({
            chargeId: charge.id,
            chargeValue: charge.value,
            contractId: currentContractId,
            consumerId: isConsumer ? selfId : null,
            generatorId: !isConsumer ? selfId : null,
            chargeStatus: "APPROVED",
          }));

          console.debug("Payload 1 (Self Charges):", selfPayload);
          apiPromises.push(bilateralContractCreate(selfPayload));
        }

        if (counterChargesList.length > 0) {
          const counterPayload = counterChargesList.map((charge) => ({
            chargeId: charge.id,
            chargeValue: charge.value,
            contractId: currentContractId,
            consumerId: !isConsumer ? counterId : null,
            generatorId: isConsumer ? counterId : null,
            chargeStatus: "INITIATED",
          }));

          console.debug(
            `Payload for Contract ${currentContractId} (Counter):`,
            counterPayload,
          );
          apiPromises.push(bilateralContractCreate(counterPayload));
        }
      });

      try {
        const results = await Promise.all(apiPromises);
        console.log("All payments initiated successfully", results);
      } catch (error) {
        console.error("Error initiating payments", error);
      }
    },
    [activeRole],
  );

  const handleTermsSubmit = useCallback(
    async (finalValues, charges) => {
      try {
        setLoading(true);
        const finalizeTermsPayload = transformToPayload(
          finalValues,
          user,
          wholeData,
          listingId,
          selectedBids,
        );

        const payloadType = isEditTerms
          ? { type: "finalize" }
          : checkPayloadType(finalValues);
        const acceptTermsPayload = getAllFinalizedConnectionIds(
          wholeData[0],
          finalValues,
          selectedBids,
        );

        let finalPayload;

        if (payloadType.type === "both") {
          // Include both finalize and accept data
          finalPayload = {
            ...finalizeTermsPayload,
            connectionIds: acceptTermsPayload,
            chargesToAccept: charges
              ?.filter((ele) => ele?.bilateralContractId)
              ?.map((ele) => ({
                bilateralContractId: ele?.bilateralContractId,
                chargeId: ele?.id,
                chargeValue: ele?.value,
                consumerId: ele?.consumerId,
                generatorId: ele?.generatorId,
                chargeStatus: "APPROVED",
              })),
            chargesToInitiate: charges
              ?.filter(
                (ele) =>
                  !ele?.bilateralContractId || ele?.entityName === "Self",
              )
              ?.map((ele) => ({
                bilateralContractId: null,
                chargeId: ele?.id,
                chargeValue: ele?.value,
                consumerId: ele?.consumerId,
                generatorId: ele?.generatorId,
                chargeStatus:
                  activeRole === "CONSUMER" && ele?.consumerId
                    ? "APPROVED"
                    : activeRole === "GENERATOR" && ele?.generatorId
                      ? "APPROVED"
                      : "INITIATED",
              })),
          };
        } else if (payloadType.type === "accept") {
          // Only include accept data
          finalPayload = {
            connectionIds: acceptTermsPayload,
            capacityId: listingId,
            userType: user,
            chargesToAccept: charges
              ?.filter((ele) => ele?.bilateralContractId)
              ?.map((ele) => ({
                bilateralContractId: ele?.bilateralContractId,
                chargeId: ele?.id,
                chargeValue: ele?.value,
                consumerId: ele?.consumerId,
                generatorId: ele?.generatorId,
                chargeStatus: "APPROVED",
              })),
          };
        } else if (payloadType.type === "finalize") {
          // Only include finalize data
          finalPayload = {
            ...finalizeTermsPayload,
            chargesToAccept: charges
              ?.filter((ele) => ele?.bilateralContractId)
              ?.map((ele) => ({
                bilateralContractId: ele?.bilateralContractId,
                chargeId: ele?.id,
                chargeValue: ele?.value,
                consumerId: ele?.consumerId,
                generatorId: ele?.generatorId,
                chargeStatus: "APPROVED",
              })),
            chargesToInitiate: charges
              ?.filter((ele) => !ele?.bilateralContractId)
              ?.map((ele) => ({
                bilateralContractId: ele?.bilateralContractId || null,
                chargeId: ele?.id,
                chargeValue: ele?.value,
                consumerId: ele?.consumerId,
                generatorId: ele?.generatorId,
                chargeStatus:
                  activeRole === "CONSUMER" && ele?.consumerId
                    ? "APPROVED"
                    : activeRole === "GENERATOR" && ele?.generatorId
                      ? "APPROVED"
                      : "INITIATED",
              })),
          };
        }

        console.log("charges11", finalPayload);

        if (
          finalPayload?.bilateralConnections &&
          Array.isArray(finalPayload.bilateralConnections) &&
          finalPayload.bilateralConnections.length === 0
        ) {
          ErrorMessage("bailateralConnections cannot be empty");
          setLoading(false);
          setConformOpen(false);
          return;
        }
        let res;
        if (isEditTerms) {
          res = await handleInitEditT_C(finalPayload);
        } else {
          res = await handleAcceptT_C(finalPayload);
        }
        console.debug("res101", res);
        if (res?.data?.code === 200) {
          // setIsEditTerms(false);
          handleClose();
          dispatch(
            fetchActiveConnection({
              curr: 0,
              capId: listingId,
              isTermsAccepted: null,
            }),
          );
          dispatch(fetchSelfCapacityById({ user, id: listingId }));
          dispatch(fetchSelfCapacity({ user }));
          dispatch(fetchMainScreenActiveConnection({ capId: listingId }));
          if (isEditTerms) {
            SuccessMessage("Terms & Conditions edited successfully!");
          } else {
            SuccessMessage("Terms & Conditions accepted successfully!");
          }
          if (window.location.pathname !== "/dashboard") {
            navigate("/dashboard");
          }
        } else {
          ErrorMessage("Failed to accept Terms & Conditions");
        }
      } catch (error) {
        console.error("Error submitting terms:", error);
        ErrorMessage("An error occurred while submitting");
      } finally {
        setConformOpen(false);
        setLoading(false);
      }
    },
    [
      transformToPayload,
      user,
      wholeData,
      listingId,
      selectedBids,
      isEditTerms,
      checkPayloadType,
      getAllFinalizedConnectionIds,
      activeRole,
      handleClose,
      dispatch,
      navigate,
    ],
  );

  const handleDirectTerms = useCallback(
    async (finalValues) => {
      try {
        setLoading(true);
        const finalizeTermsPayload = transformToPayload(
          finalValues,
          user,
          wholeData,
          listingId,
          selectedBids,
        );

        const payloadType = isEditTerms
          ? { type: "finalize" }
          : checkPayloadType(finalValues);
        console.log("🚀 ~ TermsCondition ~ payloadType:", payloadType);
        const acceptTermsPayload = getAllFinalizedConnectionIds(
          wholeData[0],
          finalValues,
          selectedBids,
        );

        let finalPayload;

        if (payloadType.type === "both") {
          // Include both finalize and accept data
          finalPayload = {
            ...finalizeTermsPayload,
            connectionIds: acceptTermsPayload,
          };
        } else if (payloadType.type === "accept") {
          // Only include accept data
          finalPayload = {
            connectionIds: acceptTermsPayload,
            capacityId: listingId,
            userType: user,
          };
        } else if (payloadType.type === "finalize") {
          // Only include finalize data
          finalPayload = {
            ...finalizeTermsPayload,
          };
        }
        console.log(
          "🚀 ~ LedgerPageDashboardActive ~ finalPayload:",
          finalPayload,
        );

        if (
          finalPayload?.bilateralConnections &&
          Array.isArray(finalPayload.bilateralConnections) &&
          finalPayload.bilateralConnections.length === 0
        ) {
          ErrorMessage("bailateralConnections cannot be empty");
          setLoading(false);
          setConformOpen(false);
          return;
        }
        // let res;
        // if (isEditTerms) {
        //   res = await handleInitEditT_C(finalPayload);
        // } else {
        // }
        let res = await handleAcceptT_C(finalPayload);
        if (res?.data?.code === 200) {
          // setIsEditTerms(false);
          handleClose();
          dispatch(
            fetchActiveConnection({
              curr: 0,
              capId: listingId,
              isTermsAccepted: null,
            }),
          );
          dispatch(fetchSelfCapacityById({ user, id: listingId }));
          dispatch(fetchSelfCapacity({ user }));
          dispatch(fetchMainScreenActiveConnection({ capId: listingId }));
          if (isEditTerms) {
            SuccessMessage("Terms & Conditions edited successfully!");
          } else {
            SuccessMessage("Terms & Conditions accepted successfully!");
          }
          if (window.location.pathname !== "/dashboard") {
            navigate("/dashboard");
          }
        } else {
          ErrorMessage("Failed to accept Terms & Conditions");
        }
      } catch (error) {
        console.error("Error submitting terms:", error);
        ErrorMessage("An error occurred while submitting");
      } finally {
        setConformOpen(false);
        setLoading(false);
      }
    },
    [
      transformToPayload,
      user,
      wholeData,
      listingId,
      selectedBids,
      isEditTerms,
      checkPayloadType,
      getAllFinalizedConnectionIds,
      handleClose,
      dispatch,
      navigate,
    ],
  );

  const handleChargeFinal = (charges) => {
    const filledValues = getAllFilledFinalValues();
    handleTermsSubmit(filledValues, charges);
  };

  useEffect(() => {
    if (!dataWithIndex?.[0]?.matches) return;

    let newSelectedBids = [...selectedBids];
    let newCollapsedCompanies = new Set(collapsedCompanies);
    let newCollapsedRequisitions = new Set(collapsedRequisitions);

    dataWithIndex[0].matches.forEach((match, matchIndex) => {
      const selfSlot = match.selfSlot;
      const counterparties = getCounterparties(match);

      counterparties.forEach((item) => {
        if (item.status === "TERMS_INITIATED") {
          // Select all matchSlots for this company
          (item.matchSlots || []).forEach((slot, slotIndex) => {
            const uniqueId = `${selfSlot?.id}-${slot.id}`;
            // Only add if not already present
            if (
              !newSelectedBids.some(
                (bid) => bid.id === slot.id && bid.selfSlotId === selfSlot?.id,
              )
            ) {
              newSelectedBids.push({
                ...slot,
                company: item.companyName,
                name: item.generatorName || item.consumerName,
                consumerGeneratorBidId: item.bidId,
                selected: true,
                selfRequisitionIndex: `${matchIndex}-${slotIndex}`,
                uniqueId,
                stableId: `${matchIndex}-${slotIndex}-${item.bidId}-${item.companyName}`,
                selfSlotId: selfSlot?.id,
                matchIndex: matchIndex, // Add matchIndex here
              });
            }
            // Ensure requisition is expanded
            newCollapsedRequisitions.delete(
              `${item.bidId}-${matchIndex}-${slot.id}`,
            );
          });
          // Ensure company is expanded
          newCollapsedCompanies.delete(`${item.bidId}-${matchIndex}`);
        }
      });
    });

    // Only update state if there are changes
    if (
      newSelectedBids.length !== selectedBids.length ||
      newCollapsedCompanies.size !== collapsedCompanies.size ||
      newCollapsedRequisitions.size !== collapsedRequisitions.size
    ) {
      setSelectedBids(newSelectedBids);
      setCollapsedCompanies(newCollapsedCompanies);
      setCollapsedRequisitions(newCollapsedRequisitions);
    }
    // eslint-disable-next-line
  }, [dataWithIndex]);

  function handleUserSelectBid(data, item, matchIndex) {
    const selfSlot = wholeData[0]?.matches?.[matchIndex]?.selfSlot;

    // Create a unique identifier that includes both selfSlot and matchSlot
    const uniqueId = `${selfSlot?.id}-${data.id}`;

    // Create the enriched bid object
    const enrichedBid = {
      ...data,
      name: item.generatorName || item.consumerName,
      company: item.companyName,
      consumerGeneratorBidId: item.bidId,
      counterpartyEntityId: item?.consumerId || item?.generatorId,
      selected: true,
      selfRequisitionIndex: `${matchIndex}-${
        item.matchSlots?.findIndex((slot) => slot.id === data.id) || 0
      }`,
      uniqueId: uniqueId,
      stableId: `${matchIndex}-${
        item.matchSlots?.findIndex((slot) => slot.id === data.id) || 0
      }-${item.bidId}-${item.companyName}`,
      selfSlotId: selfSlot?.id,
      matchIndex: matchIndex, // Add matchIndex to track requisition context
    };

    const reqKey = `${item.bidId}-${selectedSelfReq.id}-${data.id}`;

    setSelectedBids((prevSelectedBids) => {
      // Find existing bid using uniqueId (selfSlotId + matchSlotId)
      const existingIndex = prevSelectedBids.findIndex(
        (bid) => bid.uniqueId === uniqueId && bid.matchIndex === matchIndex,
      );

      if (existingIndex !== -1) {
        // Collapse the requisition when unselecting
        setCollapsedRequisitions((prev) => new Set([...prev, reqKey]));

        // Remove only this specific combination
        return prevSelectedBids.filter(
          (bid) =>
            !(bid.uniqueId === uniqueId && bid.matchIndex === matchIndex),
        );
      } else {
        // Expand the requisition when selecting
        setCollapsedRequisitions((prev) => {
          const newSet = new Set(prev);
          newSet.delete(reqKey);
          return newSet;
        });

        // Add the enriched bid
        return [...prevSelectedBids, enrichedBid];
      }
    });
  }

  // Helper function to check if company is collapsed
  const isCompanyCollapsed = (bidId, matchIndex) => {
    return collapsedCompanies.has(`${bidId}-${matchIndex}`);
  };

  // Helper function to check if requisition is collapsed
  const isRequisitionCollapsed = (bidId, matchIndex, slotId) => {
    return collapsedRequisitions.has(`${bidId}-${matchIndex}-${slotId}`);
  };

  useEffect(() => {
    // Step 1: Build mapping from selfSlot.id to index in wholeData
    let idToIndexMap = {};
    if (wholeData && Array.isArray(wholeData)) {
      wholeData.forEach((item) => {
        item.matches?.forEach((match, idx) => {
          idToIndexMap[match.selfSlot.id] = idx + 1; // 1-based index
        });
      });
    }

    // Step 2: Apply mapping to both wholeData and data
    const addIndexToMatches = (arr) =>
      arr?.map((item) => ({
        ...item,
        matches:
          item.matches?.map((match) => ({
            ...match,
            selfSlot: {
              ...match.selfSlot,
              index: idToIndexMap[match.selfSlot.id] || 1, // fallback to 1 if not found
            },
          })) ?? [],
      }));

    // Call finalData() to get the actual data
    const dataToProcess = finalData();
    if (dataToProcess && Array.isArray(dataToProcess)) {
      setDataWithIndex(addIndexToMatches(dataToProcess));
    }
  }, [wholeData, finalData]);

  // Determine if user is consumer or generator and get appropriate data
  const isConsumer = user === "consumer";
  const isGenerator = user === "generator";

  // const getListingExpiryDateTime = useCallback(() => {
  //   if (!dataWithIndex[0]) return null;

  //   const expiryDate = selfCapacityById?.listingExpDate;
  //   const expiryTime = selfCapacityById?.listingExpTime;

  //   if (!expiryDate || !expiryTime) return null;

  //   return new Date(`${expiryDate}T${expiryTime}`);
  // }, [
  //   dataWithIndex,
  //   selfCapacityById?.listingExpDate,
  //   selfCapacityById?.listingExpTime,
  // ]);

  // Get counterparties (generators for consumer, consumers for generator)
  const getCounterparties = useCallback(
    (match) => {
      return isConsumer ? match.generators : match.consumers;
    },
    [isConsumer],
  );

  // Get capacity data based on user role
  const getCapacityData = useCallback(() => {
    if (isConsumer) {
      return dataWithIndex[0]?.capacityConsumer || {};
    } else if (isGenerator) {
      return dataWithIndex[0]?.capacityGenerator || {};
    }
    return {};
  }, [dataWithIndex, isConsumer, isGenerator]);

  // Extract unique requisitions on data change
  useEffect(() => {
    if (!dataWithIndex?.[0]?.matches) return;
    const allSelfSlots = dataWithIndex[0].matches.map((match, i) => ({
      id: i,
      reqId: match.selfSlot.index,
      selfRequisitionIndex: match.selfSlot.id,
    }));
    const unique = allSelfSlots.filter(
      (item, idx, arr) =>
        arr.findIndex(
          (i) => i.selfRequisitionIndex === item.selfRequisitionIndex,
        ) === idx,
    );
    setUniqueSelfReq(unique);
    setSelectedSelfReq(unique[0]);
  }, [dataWithIndex]);

  // Get default values for a counterparty under a requisition
  const getDefaultValues = useCallback(
    (matchSlotsCount, selfSlot, matchSlots = [], counterparty = null) => {
      const capacityData = getCapacityData();
      // Check for finalizedPaymentDetails in counterparty
      const finalizedPaymentDetails = counterparty?.finalizedPaymentDetails;

      // Determine if fields should be disabled
      const isDisabled =
        (user === "consumer" && counterparty?.initiatorType === "generator") ||
        (user === "generator" && counterparty?.initiatorType === "consumer");

      let defaults = {
        paymentSecurity:
          finalizedPaymentDetails?.paymentSecurity ??
          selfSlot?.paymentSecurity ??
          capacityData.paymentSecurity ??
          "",
        initialMargin:
          finalizedPaymentDetails?.initialMargin ??
          selfSlot?.initialMargin ??
          capacityData.initialMargin ??
          "",
        emd:
          finalizedPaymentDetails?.emd ??
          selfSlot?.emd ??
          capacityData.emd ??
          "",
      };

      for (let i = 1; i <= matchSlotsCount; i++) {
        const matchSlot = matchSlots[i - 1];
        const finalizedValues = matchSlot?.finalizedConnectionValues;

        // If isEditTerms and finalizedValues exist, use those values
        if (isEditTerms && finalizedValues) {
          defaults[`req${i}_energyRate`] = finalizedValues.amount ?? "";
          defaults[`req${i}_energyRateStr`] =
            finalizedValues.energyRateType ?? "";
          defaults[`req${i}_quantity`] = finalizedValues.quantity ?? "";
          defaults[`req${i}_startDate`] = finalizedValues.dateStartAt ?? "";
          defaults[`req${i}_endDate`] = finalizedValues.dateEndAt ?? "";
          defaults[`req${i}_startTime`] = finalizedValues.slotStartAt ?? "";
          defaults[`req${i}_endTime`] = finalizedValues.slotEndAt ?? "";
        } else if (!isDisabled) {
          // User is initiator - use selfSlot values
          defaults[`req${i}_energyRate`] =
            finalizedValues?.amount ??
            selfSlot?.landingCost ??
            selfSlot?.sellingCost ??
            "";

          defaults[`req${i}_energyRateStr`] = selfSlot?.energyRateType ?? "";

          defaults[`req${i}_quantity`] =
            finalizedValues?.quantity ??
            selfSlot?.sellEnergy ??
            selfSlot?.purchaseEnergy ??
            "";

          defaults[`req${i}_startDate`] =
            finalizedValues?.dateStartAt ?? selfSlot?.dateStartAt ?? "";

          defaults[`req${i}_endDate`] =
            finalizedValues?.dateEndAt ?? selfSlot?.dateEndAt ?? "";

          defaults[`req${i}_startTime`] =
            finalizedValues?.slotStartAt ?? selfSlot?.slotStartAt ?? "";

          defaults[`req${i}_endTime`] =
            finalizedValues?.slotEndAt ?? selfSlot?.slotEndAt ?? "";
        } else {
          // Counterparty is initiator - use finalized or matchSlot values

          defaults[`req${i}_energyRate`] =
            finalizedValues?.amount ??
            matchSlot?.sellingCost ??
            matchSlot?.landingCost ??
            "";

          defaults[`req${i}_energyRateStr`] =
            finalizedValues?.energyRateType ??
            matchSlot?.energyRateType ??
            matchSlot?.energyRateType ??
            "";

          defaults[`req${i}_quantity`] =
            finalizedValues?.quantity ??
            matchSlot?.sellEnergy ??
            matchSlot?.purchaseEnergy ??
            "";

          defaults[`req${i}_startDate`] =
            finalizedValues?.dateStartAt ?? matchSlot?.dateStartAt ?? "";

          defaults[`req${i}_endDate`] =
            finalizedValues?.dateEndAt ?? matchSlot?.dateEndAt ?? "";

          defaults[`req${i}_startTime`] =
            finalizedValues?.slotStartAt ?? matchSlot?.slotStartAt ?? "";

          defaults[`req${i}_endTime`] =
            finalizedValues?.slotEndAt ?? matchSlot?.slotEndAt ?? "";
        }
      }
      return defaults;
    },
    [getCapacityData, isEditTerms, user],
  );

  // Get current values for a counterparty under a requisition
  const getCurrentValues = (counterparty, matchSlotsCount) => {
    if (!selectedSelfReq || !counterparty) return {};
    const selfSlot =
      dataWithIndex[0]?.matches?.[selectedSelfReq.id]?.selfSlot || {};
    const matchSlots = counterparty.matchSlots || [];
    const defaultValues = getDefaultValues(
      matchSlotsCount,
      selfSlot,
      matchSlots,
      counterparty,
    );
    const storedValues =
      finalValues?.[selectedSelfReq.selfRequisitionIndex]?.[
        counterparty.bidId
      ] || {};
    const sharedValues = sharedPaymentValues[counterparty.bidId] || {};

    // When type is "accept", prioritize finalizedConnectionValues
    if (type === "accept") {
      let finalizedValues = {};

      // Extract values from finalizedConnectionValues in matchSlots
      matchSlots.forEach((matchSlot, idx) => {
        if (matchSlot.finalizedConnectionValues) {
          const finalized = matchSlot.finalizedConnectionValues;
          finalizedValues[`req${idx + 1}_energyRate`] = finalized.amount ?? "";
          finalizedValues[`req${idx + 1}_energyRateStr`] =
            finalized.energyRateType ?? "";
          finalizedValues[`req${idx + 1}_quantity`] = finalized.quantity ?? "";
          finalizedValues[`req${idx + 1}_startDate`] =
            finalized.dateStartAt ?? "";
          finalizedValues[`req${idx + 1}_endDate`] = finalized.dateEndAt ?? "";
          finalizedValues[`req${idx + 1}_startTime`] =
            finalized.slotStartAt ?? "";
          finalizedValues[`req${idx + 1}_endTime`] = finalized.slotEndAt ?? "";
        }
      });

      return {
        ...defaultValues,
        ...finalizedValues,
        ...storedValues,
        paymentSecurity:
          sharedValues.paymentSecurity ??
          counterparty.finalizedPaymentDetails?.paymentSecurity ??
          defaultValues.paymentSecurity,
        initialMargin:
          sharedValues.initialMargin ??
          counterparty.finalizedPaymentDetails?.initialMargin ??
          defaultValues.initialMargin,
        emd:
          sharedValues.emd ??
          counterparty.finalizedPaymentDetails?.emd ??
          defaultValues.emd,
      };
    }

    return {
      ...defaultValues,
      ...storedValues,
      paymentSecurity:
        sharedValues.paymentSecurity ?? defaultValues.paymentSecurity,
      initialMargin: sharedValues.initialMargin ?? defaultValues.initialMargin,
      emd: sharedValues.emd ?? defaultValues.emd,
    };
  };

  // Handle input change for a field
  const handleInputChange = (e, key, counterparty, matchSlotsCount) => {
    if (!selectedSelfReq || !counterparty) return;

    // Support both event (with .target.value) and direct value (Date object/string)
    let value;
    if (e && typeof e === "object" && "target" in e && "value" in e.target) {
      value = e.target.value;
    } else {
      // e is likely a Date object or string
      value = e instanceof Date ? format(e, "yyyy-MM-dd") : e;
    }

    // Auto-select the requisition if editing a req field
    if (key.includes("req")) {
      const reqIndex = key.match(/req(\d+)_/)?.[1];
      if (reqIndex) {
        const slotIndex = parseInt(reqIndex) - 1;
        const matchSlot = counterparty.matchSlots?.[slotIndex];

        if (matchSlot) {
          const selfSlot =
            dataWithIndex[0]?.matches?.[selectedSelfReq.id]?.selfSlot;
          const uniqueId = `${selfSlot?.id}-${matchSlot.id}`;

          // Check if this slot is already selected
          const isAlreadySelected = selectedBids.some(
            (bid) =>
              bid.uniqueId === uniqueId &&
              bid.matchIndex === selectedSelfReq.id,
          );

          // If not selected, auto-select it
          if (!isAlreadySelected) {
            const enrichedBid = {
              ...matchSlot,
              name: counterparty.generatorName || counterparty.consumerName,
              company: counterparty.companyName,
              counterpartyEntityId:
                counterparty?.consumerId || counterparty?.generatorId,
              consumerGeneratorBidId: counterparty.bidId,
              selected: true,
              selfRequisitionIndex: `${selectedSelfReq.id}-${slotIndex}`,
              uniqueId: uniqueId,
              stableId: `${selectedSelfReq.id}-${slotIndex}-${counterparty.bidId}-${counterparty.companyName}`,
              selfSlotId: selfSlot?.id,
              matchIndex: selectedSelfReq.id,
            };

            setSelectedBids((prev) => [...prev, enrichedBid]);

            // Also expand the requisition and company
            const reqKey = `${counterparty.bidId}-${selectedSelfReq.id}-${matchSlot.id}`;
            const companyKey = `${counterparty.bidId}-${selectedSelfReq.id}`;

            setCollapsedRequisitions((prev) => {
              const newSet = new Set(prev);
              newSet.delete(reqKey);
              return newSet;
            });

            setCollapsedCompanies((prev) => {
              const newSet = new Set(prev);
              newSet.delete(companyKey);
              return newSet;
            });
          }
        }
      }
    }

    // Handle energy rate input - use existing energyRateType, don't parse it from value
    if (key.includes("energyRate") && !key.includes("energyRateStr")) {
      const reqIndex = key.match(/req(\d+)_energyRate/)[1];

      // Get current values to access the energy rate type
      const currentValues = getCurrentValues(counterparty, matchSlotsCount);

      // Get the current energy rate type (don't change it based on input)
      const currentEnergyRateType =
        currentValues[`req${reqIndex}_energyRateStr`] || "FIXED";

      // Just update the amount, keep the type as is
      setFinalValues((prev) => ({
        ...prev,
        [selectedSelfReq.selfRequisitionIndex]: {
          ...(prev[selectedSelfReq.selfRequisitionIndex] || {}),
          [counterparty.bidId]: {
            ...getCurrentValues(counterparty, matchSlotsCount),
            [`req${reqIndex}_energyRate`]: value,
            [`req${reqIndex}_energyRateStr`]: currentEnergyRateType,
          },
        },
      }));

      return;
    }

    const isPaymentField = ["paymentSecurity", "initialMargin", "emd"].includes(
      key,
    );

    if (isPaymentField) {
      setSharedPaymentValues((prev) => ({
        ...prev,
        [counterparty.bidId]: {
          ...prev[counterparty.bidId],
          [key]: value,
        },
      }));

      setFinalValues((prev) => {
        const newFinalValues = { ...prev };
        dataWithIndex.forEach((item) => {
          if (!item.matches) return;
          item.matches.forEach((match) => {
            const selfReqIndex = match.selfSlot.id;
            const counterparties = getCounterparties(match);
            const hasThisCounterparty = counterparties.some(
              (cp) => cp.bidId === counterparty.bidId,
            );
            if (hasThisCounterparty) {
              if (!newFinalValues[selfReqIndex]) {
                newFinalValues[selfReqIndex] = {};
              }
              if (!newFinalValues[selfReqIndex][counterparty.bidId]) {
                newFinalValues[selfReqIndex][counterparty.bidId] = {};
              }
              newFinalValues[selfReqIndex][counterparty.bidId] = {
                ...newFinalValues[selfReqIndex][counterparty.bidId],
                [key]: value,
              };
            }
          });
        });
        return newFinalValues;
      });
    } else {
      setFinalValues((prev) => ({
        ...prev,
        [selectedSelfReq.selfRequisitionIndex]: {
          ...(prev[selectedSelfReq.selfRequisitionIndex] || {}),
          [counterparty.bidId]: {
            ...getCurrentValues(counterparty, matchSlotsCount),
            [key]: value,
          },
        },
      }));
    }
  };

  // Navigation handlers
  const goToPrevReq = () => {
    const currentIdx = uniqueSelfReq.findIndex(
      (req) =>
        req.selfRequisitionIndex === selectedSelfReq?.selfRequisitionIndex,
    );
    if (currentIdx > 0) setSelectedSelfReq(uniqueSelfReq[currentIdx - 1]);
  };

  const goToNextReq = () => {
    const currentIdx = uniqueSelfReq.findIndex(
      (req) =>
        req.selfRequisitionIndex === selectedSelfReq?.selfRequisitionIndex,
    );
    if (currentIdx < uniqueSelfReq.length - 1)
      setSelectedSelfReq(uniqueSelfReq[currentIdx + 1]);
  };

  // Helper to get all filled values for submission
  const getAllFilledFinalValues = () => {
    const result = {};
    if (!Array.isArray(dataWithIndex)) return result;

    try {
      // Check if any bids are selected
      if (selectedBids.length === 0) {
        toast.error("Please select at least one requisition.");
        throw new Error("NO_BIDS_SELECTED");
      }

      // Helper: max duration (in days) for selected slots of a counterparty within a match
      const getMaxSelectedDurationDays = (
        match,
        counterparty,
        matchSlots,
        selfReqIndex,
        bidId,
        matchIndex,
      ) => {
        let maxDays = null;
        const storedValues = finalValues?.[selfReqIndex]?.[bidId] || {};

        matchSlots.forEach((slot, idx) => {
          const isSlotSelected = selectedBids.some(
            (bid) =>
              bid.id === slot.id &&
              bid.selfSlotId === match.selfSlot.id &&
              bid.consumerGeneratorBidId == bidId &&
              (bid.matchIndex === matchIndex || bid.matchIndex === undefined),
          );

          if (!isSlotSelected) return;

          const startDate =
            storedValues[`req${idx + 1}_startDate`] || slot.dateStartAt;
          const endDate =
            storedValues[`req${idx + 1}_endDate`] || slot.dateEndAt;

          if (startDate && endDate) {
            const start = new Date(startDate);
            const end = new Date(endDate);
            const durationDays =
              Math.max(0, Math.ceil((end - start) / (1000 * 60 * 60 * 24))) + 1;
            maxDays =
              maxDays === null ? durationDays : Math.max(maxDays, durationDays);
          }
        });

        return maxDays;
      };

      // Step 1: Collect all energy rate types for each counterparty across all matches/requisitions (only for selected bids)
      const counterpartyEnergyTypes = {}; // { [bidId]: array of types }
      const counterpartyNames = {}; // { [bidId]: companyName }

      dataWithIndex.forEach((item) => {
        if (!item.matches) return;

        item.matches.forEach((match, matchIndex) => {
          const selfReqIndex = String(match.selfSlot.id);
          const counterparties = getCounterparties(match);

          counterparties.forEach((counterparty) => {
            const bidId = String(counterparty.bidId);
            const matchSlots = counterparty.matchSlots || [];

            // Check if this counterparty has any selected slots in this match
            const hasSelectedSlots = matchSlots.some((slot) =>
              selectedBids.some(
                (bid) =>
                  bid.id === slot.id &&
                  bid.selfSlotId === match.selfSlot.id &&
                  bid.consumerGeneratorBidId == bidId &&
                  (bid.matchIndex === matchIndex ||
                    bid.matchIndex === undefined),
              ),
            );

            // Skip this counterparty if no slots are selected
            if (!hasSelectedSlots) return;

            // Store counterparty name
            counterpartyNames[bidId] = counterparty.companyName;

            const matchSlotsCount = matchSlots.length;
            const selfSlot = match.selfSlot;

            const defaultValues = getDefaultValues(
              matchSlotsCount,
              selfSlot,
              matchSlots,
              counterparty,
            );

            const storedValues = finalValues?.[selfReqIndex]?.[bidId] || {};
            const sharedValues = sharedPaymentValues[bidId] || {};

            const paymentSecurity =
              sharedValues.paymentSecurity ?? defaultValues.paymentSecurity;
            const initialMargin =
              sharedValues.initialMargin ?? defaultValues.initialMargin;

            // Validate Initial Margin range (100-200)
            // if (
            //   initialMargin !== "" &&
            //   initialMargin !== undefined &&
            //   initialMargin !== null
            // ) {
            //   const marginValue = Number(initialMargin);
            //   if (
            //     isNaN(marginValue) ||
            //     marginValue < 100 ||
            //     marginValue > 200
            //   ) {
            //     toast.error(
            //       `Initial Margin must be between 100 and 200 for counterparty ${counterparty.companyName}.`,
            //     );
            //     throw new Error("INITIAL_MARGIN_OUT_OF_RANGE");
            //   }
            // }

            // Validate Payment Security only when this counterparty has selected slots
            const maxSelectedDays = getMaxSelectedDurationDays(
              match,
              counterparty,
              matchSlots,
              selfReqIndex,
              bidId,
              matchIndex,
            );

            // if (
            //   maxSelectedDays !== null &&
            //   paymentSecurity !== "" &&
            //   paymentSecurity !== undefined &&
            //   paymentSecurity !== null
            // ) {
            //   if (Number(paymentSecurity) > maxSelectedDays) {
            //     toast.error(
            //       `Payment Security (${paymentSecurity} days) for counterparty ${counterparty.companyName} cannot exceed the maximum requirement duration of ${maxSelectedDays} day(s) for the selected requisition(s).`,
            //     );
            //     throw new Error("PAYMENT_SECURITY_EXCEEDS_DURATION");
            //   }
            // }

            // Initialize array for this counterparty if not exists
            if (!counterpartyEnergyTypes[bidId])
              counterpartyEnergyTypes[bidId] = [];

            // Collect energy rate types only for selected slots
            for (let idx = 0; idx < matchSlots.length; idx++) {
              const matchSlot = matchSlots[idx];

              // Check if this slot is selected
              const isSlotSelected = selectedBids.some(
                (bid) =>
                  bid.id === matchSlot.id &&
                  bid.selfSlotId === match.selfSlot.id &&
                  bid.consumerGeneratorBidId == bidId &&
                  (bid.matchIndex === matchIndex ||
                    bid.matchIndex === undefined),
              );

              if (!isSlotSelected) continue; // Skip unselected slots

              const energyRate =
                storedValues[`req${idx + 1}_energyRate`] ??
                defaultValues[`req${idx + 1}_energyRate`];
              const energyRateType =
                storedValues[`req${idx + 1}_energyRateStr`] ??
                defaultValues[`req${idx + 1}_energyRateStr`];

              // Validate that amount is a valid number
              if (
                energyRate !== "" &&
                energyRate !== undefined &&
                energyRate !== null
              ) {
                if (isNaN(Number(energyRate))) {
                  toast.error(
                    `Invalid energy rate value "${energyRate}" in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}. Please enter a valid number.`,
                  );
                  throw new Error("INVALID_ENERGY_RATE_VALUE");
                }
              }

              // Determine the type based on energyRateType
              if (
                energyRateType === "DAM_PLUS" ||
                energyRateType === "DAM_MINUS"
              ) {
                counterpartyEnergyTypes[bidId].push("DAM");
              } else if (energyRateType === "FIXED") {
                counterpartyEnergyTypes[bidId].push("FIXED");
              } else {
                counterpartyEnergyTypes[bidId].push("OTHER");
              }
            }
          });
        });
      });

      // Step 2: Validate that each counterparty has only one type across all matches/requisitions
      for (const [bidId, typesArr] of Object.entries(counterpartyEnergyTypes)) {
        const uniqueTypes = [...new Set(typesArr)];
        if (uniqueTypes.length > 1) {
          toast.error(
            `All Energy Rate values for counterparty ${counterpartyNames[bidId]} must be of the same type (all FIXED or all DAM-based) across all selected requisitions.`,
          );
          throw new Error("INCONSISTENT_ENERGY_RATE_TYPE");
        }

        // // Validate DAM values don't contain decimals (only for selected slots)
        // const hasDAM = uniqueTypes.includes("DAM");
        // if (hasDAM) {
        //   let hasDecimalDAM = false;
        //   let decimalReqIndex = null;

        //   dataWithIndex.forEach((item) => {
        //     if (!item.matches) return;

        //     item.matches.forEach((match, matchIndex) => {
        //       const selfReqIndex = String(match.selfSlot.id);
        //       const counterparties = getCounterparties(match);

        //       counterparties.forEach((counterparty) => {
        //         if (String(counterparty.bidId) !== bidId) return;

        //         const matchSlots = counterparty.matchSlots || [];
        //         const selfSlot = match.selfSlot;

        //         const defaultValues = getDefaultValues(
        //           matchSlots.length,
        //           selfSlot,
        //           matchSlots,
        //           counterparty
        //         );

        //         const storedValues = finalValues?.[selfReqIndex]?.[bidId] || {};

        //         for (let idx = 0; idx < matchSlots.length; idx++) {
        //           const matchSlot = matchSlots[idx];

        //           // Check if this slot is selected
        //           const isSlotSelected = selectedBids.some(
        //             (bid) =>
        //               bid.id === matchSlot.id &&
        //               bid.selfSlotId === selfSlot.id &&
        //               bid.consumerGeneratorBidId == bidId &&
        //               (bid.matchIndex === matchIndex ||
        //                 bid.matchIndex === undefined)
        //           );

        //           if (!isSlotSelected) continue; // Skip unselected slots

        //           const energyRate =
        //             storedValues[`req${idx + 1}_energyRate`] ??
        //             defaultValues[`req${idx + 1}_energyRate`];
        //           const energyRateType =
        //             storedValues[`req${idx + 1}_energyRateStr`] ??
        //             defaultValues[`req${idx + 1}_energyRateStr`];

        //           if (
        //             (energyRateType === "DAM_PLUS" ||
        //               energyRateType === "DAM_MINUS") &&
        //             energyRate !== "" &&
        //             energyRate !== undefined &&
        //             energyRate !== null
        //           ) {
        //             const rateValue = String(energyRate).trim();
        //             // Check if it contains a decimal point or is a float
        //             if (
        //               rateValue.includes(".") ||
        //               !Number.isInteger(Number(rateValue))
        //             ) {
        //               hasDecimalDAM = true;
        //               decimalReqIndex = match.selfSlot.index;
        //               break;
        //             }
        //           }
        //         }

        //         if (hasDecimalDAM) return;
        //       });

        //       if (hasDecimalDAM) return;
        //     });

        //     if (hasDecimalDAM) return;
        //   });

        //   if (hasDecimalDAM) {
        //     toast.error(
        //       `DAM-based Energy Rate values for counterparty ${counterpartyNames[bidId]} must be whole numbers (no decimals) in Requisition ${decimalReqIndex}.`
        //     );
        //     throw new Error("DECIMAL_DAM_VALUE");
        //   }
        // }
      }

      // Step 3: Build the result only for selected bids
      dataWithIndex.forEach((item) => {
        if (!item.matches) return;

        item.matches.forEach((match, matchIndex) => {
          const selfReqIndex = String(match.selfSlot.id);
          const counterparties = getCounterparties(match);

          counterparties.forEach((counterparty, i) => {
            const bidId = String(counterparty.bidId);
            const matchSlots = counterparty.matchSlots || [];
            const selfSlot = match.selfSlot;

            // Check if this counterparty has any selected slots in this match
            const hasSelectedSlots = matchSlots.some((slot) =>
              selectedBids.some(
                (bid) =>
                  bid.id === slot.id &&
                  bid.selfSlotId === match.selfSlot.id &&
                  bid.consumerGeneratorBidId == bidId &&
                  (bid.matchIndex === matchIndex ||
                    bid.matchIndex === undefined),
              ),
            );

            // Skip this counterparty if no slots are selected
            if (!hasSelectedSlots) return;

            const matchSlotsCount = matchSlots.length;

            const defaultValues = getDefaultValues(
              matchSlotsCount,
              selfSlot,
              matchSlots,
              counterparty,
            );

            const storedValues = finalValues?.[selfReqIndex]?.[bidId] || {};
            const sharedValues = sharedPaymentValues[bidId] || {};

            // Check payment fields
            const paymentSecurity =
              sharedValues.paymentSecurity ?? defaultValues.paymentSecurity;
            const initialMargin =
              sharedValues.initialMargin ?? defaultValues.initialMargin;
            const emd = sharedValues.emd ?? defaultValues.emd;

            if (
              paymentSecurity === "" ||
              paymentSecurity === undefined ||
              initialMargin === "" ||
              initialMargin === undefined ||
              emd === "" ||
              emd === undefined
            ) {
              toast.error(
                `All payment fields (Payment Security, Initial Margin, EMD) are required for counterparty ${counterparty.companyName}.`,
              );
              throw new Error("EMPTY_PAYMENT_FIELD");
            }

            // Validate only selected slots
            for (let idx = 0; idx < matchSlots.length; idx++) {
              const matchSlot = matchSlots[idx];

              // Check if this slot is selected
              const isSlotSelected = selectedBids.some(
                (bid) =>
                  bid.id === matchSlot.id &&
                  bid.selfSlotId === match.selfSlot.id &&
                  bid.consumerGeneratorBidId == bidId &&
                  (bid.matchIndex === matchIndex ||
                    bid.matchIndex === undefined),
              );

              if (!isSlotSelected) continue; // Skip unselected slots

              const energyRate =
                storedValues[`req${idx + 1}_energyRate`] ??
                defaultValues[`req${idx + 1}_energyRate`];
              const energyRateType =
                storedValues[`req${idx + 1}_energyRateStr`] ??
                defaultValues[`req${idx + 1}_energyRateStr`];
              const quantity =
                storedValues[`req${idx + 1}_quantity`] ??
                defaultValues[`req${idx + 1}_quantity`];
              const startDate =
                storedValues[`req${idx + 1}_startDate`] ||
                defaultValues[`req${idx + 1}_startDate`];
              const endDate =
                storedValues[`req${idx + 1}_endDate`] ||
                defaultValues[`req${idx + 1}_endDate`];
              const startTime =
                storedValues[`req${idx + 1}_startTime`] ||
                defaultValues[`req${idx + 1}_startTime`];
              const endTime =
                storedValues[`req${idx + 1}_endTime`] ||
                defaultValues[`req${idx + 1}_endTime`];

              // Empty check for slot fields
              // For energyRate: if energyRateType is not FIXED, allow 0

              const isEnergyRateInvalid =
                energyRateType === "FIXED"
                  ? energyRate === "" ||
                    energyRate === undefined ||
                    energyRate === null ||
                    Number(energyRate) === 0
                  : energyRate === "" ||
                    energyRate === undefined ||
                    energyRate === null;

              if (
                isEnergyRateInvalid ||
                quantity === "" ||
                quantity === undefined ||
                startDate === "" ||
                startDate === undefined ||
                endDate === "" ||
                endDate === undefined ||
                startTime === "" ||
                startTime === undefined ||
                endTime === "" ||
                endTime === undefined
              ) {
                // Show specific message for FIXED type with 0 value
                if (energyRateType === "FIXED" && Number(energyRate) === 0) {
                  toast.error(
                    `Energy Rate cannot be zero for FIXED rate type in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`,
                  );
                  throw new Error("ZERO_ENERGY_RATE_FIXED");
                }

                toast.error(
                  `All fields are required in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`,
                );
                throw new Error("EMPTY_FIELD");
              }

              const maxQuantity = getMaxQuantity();
              const quantityValue = parseFloat(quantity);

              if (isNaN(quantityValue) || quantityValue <= 0) {
                toast.error(
                  `Quantity must be greater than zero in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`,
                );
                throw new Error("INVALID_QUANTITY_ZERO");
              }

              if (maxQuantity && quantityValue > maxQuantity) {
                toast.error(
                  `Quantity (${quantityValue} MW) cannot exceed maximum capacity of ${maxQuantity} MW in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`,
                );
                throw new Error("QUANTITY_EXCEEDS_MAX");
              }

              // Validate dates only
              if (startDate && endDate) {
                const startDateObj = new Date(startDate);
                const endDateObj = new Date(endDate);

                if (startDateObj > endDateObj) {
                  toast.error(
                    `Start Date cannot be greater than End Date in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`,
                  );
                  throw new Error("INVALID_DATE");
                }
              }

              // const listingExpiryDateTime = getListingExpiryDateTime();

              // if (listingExpiryDateTime && startDate && startTime) {
              //   const startDateTime = new Date(`${startDate}T${startTime}`);

              //   // Calculate minimum allowed start time (3 hours before expiry)
              //   const minAllowedStartTime = new Date(listingExpiryDateTime);
              //   minAllowedStartTime.setHours(
              //     minAllowedStartTime.getHours() + 3
              //   );

              //   if (startDateTime < minAllowedStartTime) {
              //     const expiryDateStr = format(
              //       listingExpiryDateTime,
              //       "dd/MM/yyyy"
              //     );
              //     const expiryTimeStr = format(listingExpiryDateTime, "HH:mm");
              //     const minAllowedDateStr = format(
              //       minAllowedStartTime,
              //       "dd/MM/yyyy"
              //     );
              //     const minAllowedTimeStr = format(
              //       minAllowedStartTime,
              //       "HH:mm"
              //     );

              //     toast.error(
              //       `Start Date & Time must be at least 3 hours before listing expiry date (${expiryDateStr} ${expiryTimeStr}). Minimum allowed: ${minAllowedDateStr} ${minAllowedTimeStr} in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`
              //     );
              //     throw new Error("START_DATETIME_TOO_CLOSE_TO_EXPIRY");
              //   }
              // }

              // Validate times only (when dates are equal)
              if (startTime && endTime) {
                if (startTime > endTime) {
                  toast.error(
                    `Start Time cannot be greater than End Time in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`,
                  );
                  throw new Error("INVALID_TIME");
                }
              }

              // Validate combined date-time
              if (startDate && endDate && startTime && endTime) {
                const startDateTime = new Date(`${startDate}T${startTime}`);
                const endDateTime = new Date(`${endDate}T${endTime}`);

                if (startDateTime >= endDateTime) {
                  toast.error(
                    `Start Date & Time must be before End Date & Time in Requisition ${match.selfSlot.index} for counterparty ${counterparty.companyName}.`,
                  );
                  throw new Error("INVALID_DATE_TIME");
                }
              }
            }

            // Initialize result for this requisition if not exists
            if (!result[selfReqIndex]) {
              result[selfReqIndex] = {};
            }

            result[selfReqIndex][bidId] = {
              ...defaultValues,
              ...storedValues,
              id: matchSlots[i]?.id || "",
              paymentSecurity:
                sharedValues.paymentSecurity ?? defaultValues.paymentSecurity,
              initialMargin:
                sharedValues.initialMargin ?? defaultValues.initialMargin,
              emd: sharedValues.emd ?? defaultValues.emd,
            };
          });
        });
      });
    } catch (err) {
      console.warn("Validation stopped submission:", err.message);
      return null;
    }

    return result;
  };

  const isAllSlotsSelected = useCallback(
    (bidId, matchIndex) => {
      if (!dataWithIndex[0]?.matches?.[matchIndex]) return false;

      const counterparties = getCounterparties(
        dataWithIndex[0].matches[matchIndex],
      );
      const counterparty = counterparties.find((cp) => cp.bidId === bidId);

      if (!counterparty?.matchSlots) return false;

      const selfSlot = dataWithIndex[0].matches[matchIndex].selfSlot;

      // Check if all slots for this specific requisition are selected
      return counterparty.matchSlots.every((slot) =>
        selectedBids.some(
          (bid) =>
            bid.id === slot.id &&
            bid.selfSlotId === selfSlot.id &&
            bid.matchIndex === matchIndex,
        ),
      );
    },
    [dataWithIndex, selectedBids, getCounterparties],
  );

  // Add this handler for company-level toggle
  const handleCompanyToggle = useCallback(
    (item, matchIndex) => {
      const allSlots = item.matchSlots || [];
      const selfSlot = wholeData[0]?.matches?.[matchIndex]?.selfSlot;

      // Check if all slots for THIS requisition are selected
      const allSelected = allSlots.every((slot) =>
        selectedBids.some(
          (bid) =>
            bid.id === slot.id &&
            bid.selfSlotId === selfSlot?.id &&
            bid.matchIndex === matchIndex,
        ),
      );

      const companyKey = `${item.bidId}-${matchIndex}`;

      setSelectedBids((prevSelectedBids) => {
        if (allSelected) {
          // Collapse the company when unselecting
          setCollapsedCompanies((prev) => new Set([...prev, companyKey]));

          // Remove only slots for THIS requisition
          return prevSelectedBids.filter(
            (bid) =>
              !(
                allSlots.some((slot) => slot.id === bid.id) &&
                bid.selfSlotId === selfSlot?.id &&
                bid.matchIndex === matchIndex
              ),
          );
        } else {
          // Expand the company when selecting
          setCollapsedCompanies((prev) => {
            const newSet = new Set(prev);
            newSet.delete(companyKey);
            return newSet;
          });

          // Add only slots for THIS requisition that aren't already selected
          const slotsToAdd = allSlots.filter(
            (slot) =>
              !prevSelectedBids.some(
                (bid) =>
                  bid.id === slot.id &&
                  bid.selfSlotId === selfSlot?.id &&
                  bid.matchIndex === matchIndex,
              ),
          );

          // Map the slots with enriched data format
          const mappedSlots = slotsToAdd.map((slot, slotIndex) => ({
            ...slot,
            name: item.generatorName || item.consumerName,
            company: item.companyName,
            counterpartyEntityId: item?.consumerId || item?.generatorId,
            consumerGeneratorBidId: item.bidId,
            selected: true,
            selfRequisitionIndex: `${matchIndex}-${
              item.matchSlots?.findIndex((s) => s.id === slot.id) || slotIndex
            }`,
            uniqueId: `${selfSlot?.id}-${slot.id}`,
            stableId: `${matchIndex}-${
              item.matchSlots?.findIndex((s) => s.id === slot.id) || slotIndex
            }-${item.bidId}-${item.companyName}`,
            selfSlotId: selfSlot?.id,
            matchIndex: matchIndex, // Add matchIndex to track requisition context
          }));

          return [...prevSelectedBids, ...mappedSlots];
        }
      });
    },
    [selectedBids, wholeData],
  );

  const calculateBucketFillPercentage = useCallback(
    (matchIndex) => {
      if (!dataWithIndex[0]?.matches?.[matchIndex]) return 0;

      const match = dataWithIndex[0].matches[matchIndex];
      const selfSlot = match.selfSlot;
      const totalCapacity = selfSlot.purchaseEnergy || selfSlot.sellEnergy || 0;

      if (totalCapacity === 0) return 0;

      // Get all counterparties for this requisition
      const counterparties = getCounterparties(match);

      // Calculate total selected quantity for this requisition
      let totalSelectedQuantity = 0;

      counterparties.forEach((counterparty) => {
        const matchSlots = counterparty.matchSlots || [];
        const selfReqIndex = String(selfSlot.id);

        // Get default values for this counterparty
        const defaultValues = getDefaultValues(
          matchSlots.length,
          selfSlot,
          matchSlots,
          counterparty,
        );

        counterparty.matchSlots?.forEach((slot, slotIndex) => {
          // Check if this slot is selected
          const isSelected = selectedBids.some(
            (bid) =>
              bid.id === slot.id &&
              bid.selfSlotId === selfSlot.id &&
              bid.matchIndex === matchIndex,
          );

          if (isSelected) {
            // Check if user has edited the quantity in finalValues
            const editedQuantity =
              finalValues?.[selfReqIndex]?.[counterparty.bidId]?.[
                `req${slotIndex + 1}_quantity`
              ];

            // Use edited quantity if available, otherwise use default value
            const quantity = parseFloat(
              editedQuantity ?? defaultValues[`req${slotIndex + 1}_quantity`],
            );

            // Only add valid numbers
            if (!isNaN(quantity) && quantity > 0) {
              totalSelectedQuantity += quantity;
            }
          }
        });
      });

      // Calculate percentage without capping at 100%
      const percentage = (totalSelectedQuantity / totalCapacity) * 100;

      // Return 0 if percentage is NaN or invalid
      return isNaN(percentage) ? 0 : Math.round(percentage);
    },
    [
      dataWithIndex,
      selectedBids,
      getCounterparties,
      finalValues,
      getDefaultValues,
    ],
  );

  const handleRejectAllTermsSubmit = useCallback(
    async (e, data) => {
      // Collect IDs from mainScreenMatchData where status is PENDING and initiatorType !== user
      const contractIds = (mainScreenMatchData || [])
        .filter(
          (item) =>
            item.status === "PENDING" &&
            item.initiatorType &&
            item.initiatorType.toLowerCase() !== user,
        )
        .map((item) => item.id);

      const payload = {
        contractIds: contractIds,
      };
      console.log("🚀 ~ TermsCondition ~ payload:", payload);

      try {
        setRejectLoading(true);
        const res = await handleRejectAllT_C(payload);
        if (res?.data?.code === 200) {
          dispatch(
            fetchActiveConnection({
              curr: 0,
              capId: listingId,
              isTermsAccepted: null,
            }),
          );

          dispatch(fetchSelfCapacityById({ user, id: listingId }));
          dispatch(fetchSelfCapacity({ user }));
          dispatch(fetchMainScreenActiveConnection({ capId: listingId }));
          dispatch(fetchLedgerBids(listingId));
          setRejectAllTermsConfirm(false);
          SuccessMessage("Terms & Conditions rejected successfully!");
          handleClose();
          if (window.location.pathname !== "/dashboard") {
            navigate("/dashboard");
          }
        }
      } catch (error) {
        ErrorMessage("An error occurred while rejecting terms.");
      } finally {
        setRejectLoading(false);
      }
    },
    [dispatch, handleClose, listingId, mainScreenMatchData, navigate, user],
  );

  const handleDirectTermsSumbit = async (
    contracts,
    chargeStatus = "APPROVED",
  ) => {
    try {
      // 1. Create an array of API call promises
      const updatePromises =
        contracts?.map((contract) =>
          updateContract({
            contractId: contract.contractId,
            chargeStatus: chargeStatus,
          }),
        ) || [];

      // 2. Wait for ALL updates to complete
      await Promise.all(updatePromises);

      // 3. Call the final function only after updates succeed
      if (chargeStatus === "APPROVED") {
        const filledValues = getAllFilledFinalValues();
        handleDirectTerms(filledValues);
      }
    } catch (error) {
      console.error("Error updating contracts:", error);
    } finally {
    }
  };

  const handleEnergyRateTypeChange = useCallback(
    (newType, counterparty, matchIndex) => {
      if (!selectedSelfReq || !counterparty) return;

      // Check if switching between Fixed and DAM types
      let hasOtherFixed = false;
      let hasOtherDAM = false;

      // Check all requisitions for this counterparty to find existing types
      dataWithIndex.forEach((item) => {
        if (!item.matches) return;

        item.matches.forEach((match, mIdx) => {
          const selfReqIndex = String(match.selfSlot.id);
          const counterparties = getCounterparties(match);
          const sameCounterparty = counterparties.find(
            (cp) => cp.bidId === counterparty.bidId,
          );

          if (sameCounterparty) {
            const storedValues =
              finalValues?.[selfReqIndex]?.[counterparty.bidId] || {};
            const matchSlotsCount = sameCounterparty.matchSlots?.length || 0;

            // Get default values to check initial state
            const selfSlot = match.selfSlot;
            const matchSlots = sameCounterparty.matchSlots || [];
            const defaultValues = getDefaultValues(
              matchSlotsCount,
              selfSlot,
              matchSlots,
              sameCounterparty,
            );

            for (let i = 1; i <= matchSlotsCount; i++) {
              // Check stored value first, then fall back to default
              const existingType =
                storedValues[`req${i}_energyRateStr`] ||
                defaultValues[`req${i}_energyRateStr`];

              if (existingType === "FIXED") hasOtherFixed = true;
              if (existingType === "DAM_PLUS" || existingType === "DAM_MINUS")
                hasOtherDAM = true;
            }
          }
        });
      });

      const isNewFixed = newType === "FIXED";
      const isNewDAM = newType === "DAM_PLUS" || newType === "DAM_MINUS";

      // Check if switching between Fixed and DAM types (not between DAM+ and DAM-)
      const needsSwitch =
        (isNewFixed && hasOtherDAM) || (isNewDAM && hasOtherFixed);

      if (needsSwitch) {
        // Clear all energy rate values and update all requisitions to the new type
        setFinalValues((prev) => {
          const newFinalValues = { ...prev };

          dataWithIndex.forEach((item) => {
            if (!item.matches) return;

            item.matches.forEach((match, mIdx) => {
              const selfReqIndex = String(match.selfSlot.id);
              const counterparties = getCounterparties(match);

              const sameCounterparty = counterparties.find(
                (cp) => cp.bidId === counterparty.bidId,
              );

              if (sameCounterparty) {
                if (!newFinalValues[selfReqIndex]) {
                  newFinalValues[selfReqIndex] = {};
                }
                if (!newFinalValues[selfReqIndex][counterparty.bidId]) {
                  newFinalValues[selfReqIndex][counterparty.bidId] = {};
                }

                const matchSlotsCount =
                  sameCounterparty.matchSlots?.length || 0;

                // Clear all energy rate values and update type
                for (let i = 1; i <= matchSlotsCount; i++) {
                  newFinalValues[selfReqIndex][counterparty.bidId][
                    `req${i}_energyRate`
                  ] = "";
                  newFinalValues[selfReqIndex][counterparty.bidId][
                    `req${i}_energyRateStr`
                  ] = newType;
                }
              }
            });
          });

          return newFinalValues;
        });

        toast.success(
          `Switched all requisitions to ${
            newType === "FIXED"
              ? "Fixed"
              : newType === "DAM_PLUS"
                ? "DAM+"
                : "DAM-"
          } for ${counterparty.companyName}. Please enter energy rates again.`,
        );
      } else {
        // Just update the current requisition's slots (switching between DAM+ and DAM- or same category)
        setFinalValues((prev) => {
          const newFinalValues = { ...prev };
          const selfReqIndex = String(
            dataWithIndex[0].matches[matchIndex].selfSlot.id,
          );

          if (!newFinalValues[selfReqIndex]) {
            newFinalValues[selfReqIndex] = {};
          }
          if (!newFinalValues[selfReqIndex][counterparty.bidId]) {
            newFinalValues[selfReqIndex][counterparty.bidId] = {};
          }

          const matchSlotsCount = counterparty.matchSlots?.length || 0;

          // Only update the type for current requisition, keep the values
          for (let i = 1; i <= matchSlotsCount; i++) {
            const currentRate =
              newFinalValues[selfReqIndex][counterparty.bidId][
                `req${i}_energyRate`
              ];

            newFinalValues[selfReqIndex][counterparty.bidId][
              `req${i}_energyRateStr`
            ] = newType;

            // Keep the existing rate value
            if (currentRate !== undefined) {
              newFinalValues[selfReqIndex][counterparty.bidId][
                `req${i}_energyRate`
              ] = currentRate;
            }
          }

          return newFinalValues;
        });
      }
    },
    [
      selectedSelfReq,
      dataWithIndex,
      getCounterparties,
      finalValues,
      getDefaultValues,
    ],
  );

  return (
    <>
      {chargeModal && (
        <ChargeSelection
          loading={loading}
          open={chargeModal}
          handleClose={() => setChargeModal(false)}
          handleSubmit={handleChargeFinal}
          details={chargeDetails}
          handleDirectSubmit={handleDirectTermsSumbit}
          type={type}
          setRejectContract={setRejectContract}
          setRejectAllTermsConfirm={setRejectAllTermsConfirm}
          mainScreenMatchData={mainScreenMatchData}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.modalMainCont}`}>
          <div className="modalHeading">
            <div style={{ color: "var(--fourth-color-text)", fontWeight: 500 }}>
              {type === "accept"
                ? "Approve Finalized T&C"
                : isEditTerms
                  ? "Edit T&C"
                  : "Finalize T&C"}
            </div>
            <Close
              onClick={handleClose}
              style={{ cursor: "pointer" }}
              alterbutton="false"
            />
          </div>
          <div className={Styles.termsMainContainer}>
            {/* Requisition Tabs UI */}
            <div className={Styles.reqTabsContainer}>
              <button
                className={Styles.arrowBtn}
                onClick={goToPrevReq}
                disabled={
                  uniqueSelfReq.findIndex(
                    (req) =>
                      req.selfRequisitionIndex ===
                      selectedSelfReq?.selfRequisitionIndex,
                  ) === 0
                }
              >
                &laquo;
              </button>
              {uniqueSelfReq?.map((req, idx) => {
                return (
                  <button
                    key={req.selfRequisitionIndex}
                    className={
                      selectedSelfReq?.selfRequisitionIndex ===
                      req.selfRequisitionIndex
                        ? Styles.reqTabActive
                        : Styles.reqTab
                    }
                    onClick={() => setSelectedSelfReq(req)}
                  >
                    {`Requisition ${req.reqId}`}
                  </button>
                );
              })}
              <button
                className={Styles.arrowBtn}
                onClick={goToNextReq}
                disabled={
                  uniqueSelfReq.findIndex(
                    (req) =>
                      req.selfRequisitionIndex ===
                      selectedSelfReq?.selfRequisitionIndex,
                  ) ===
                  uniqueSelfReq.length - 1
                }
              >
                &raquo;
              </button>
            </div>

            <div className={Styles.tableHeadingCustom}>
              <div
                style={{
                  flexBasis: "210px",
                  minWidth: "210px",
                  maxWidth: "210px",
                  width: "210px",
                }}
              >
                Category
              </div>
              <div>My Listing</div>
              <div>Counterparty Listing</div>
              <div
                style={{ display: "flex", justifyContent: "space-between" }}
                className={Styles.finalValues}
              >
                Final Values{" "}
                <div>
                  {selectedSelfReq && (
                    <div className={Styles.bucketFillContainer}>
                      <div className={Styles.bucketCircle}>
                        <svg width="35" height="35" viewBox="0 0 40 40">
                          {/* Background circle */}
                          <circle
                            cx="20"
                            cy="20"
                            r="16"
                            fill="none"
                            stroke="#E0E0E0"
                            strokeWidth="3"
                          />
                          {/* Progress circle with animation */}
                          <circle
                            cx="20"
                            cy="20"
                            r="16"
                            fill="none"
                            stroke="#00BF6F"
                            strokeWidth="3"
                            strokeDasharray={`${
                              (calculateBucketFillPercentage(
                                selectedSelfReq.id,
                              ) *
                                100.5) /
                              100
                            } 100.5`}
                            strokeLinecap="round"
                            transform="rotate(-90 20 20)"
                            className={Styles.progressCircle}
                          />
                          {/* Percentage text */}
                          <text
                            x="20"
                            y="23"
                            textAnchor="middle"
                            fontSize="9"
                            fontWeight="600"
                            fill="#00BF6F"
                          >
                            {calculateBucketFillPercentage(selectedSelfReq.id)}%
                          </text>
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {selectedSelfReq &&
              dataWithIndex[0]?.matches?.[selectedSelfReq.id] &&
              getCounterparties(
                dataWithIndex[0].matches[selectedSelfReq.id],
              ).map((item, i) => {
                const matchSlotsCount = item.matchSlots?.length || 1;
                const currentValues = getCurrentValues(item, matchSlotsCount);

                const selfSlot =
                  dataWithIndex[0].matches[selectedSelfReq.id].selfSlot;
                const isDisabled =
                  (user === "consumer" && item.initiatorType === "generator") ||
                  (user === "generator" && item.initiatorType === "consumer");
                const isIntraday = item?.isIntraDay;
                const isCollapsed = isCompanyCollapsed(
                  item.bidId,
                  selectedSelfReq.id,
                );

                return (
                  <div
                    key={item.bidId}
                    className={Styles.tableDetailsMainContCustom}
                  >
                    <div className={Styles.sectionBox}>
                      <div
                        style={{
                          backgroundColor: "#52888f",
                          borderRadius: "20px",
                        }}
                        className={Styles.row}
                      >
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "12px",
                            flex: "0 0",
                            marginRight: "15px",
                          }}
                        >
                          <span style={{ color: "white", textWrap: "nowrap" }}>
                            {" "}
                            {item.generatorName || item.consumerName}{" "}
                          </span>
                          {item.status === "TERMS_INITIATED" &&
                            item.initiatorType !== user &&
                            !isEditTerms && (
                              <span
                                style={{
                                  fontWeight: "500",
                                  fontSize: "10px",
                                  marginLeft: "8px",
                                  color: "white",
                                  textWrap: "nowrap",
                                }}
                              >
                                (T&C Request Received)
                              </span>
                            )}
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          {!isEditTerms && (
                            <AntSwitch
                              checked={isAllSlotsSelected(
                                item.bidId,
                                selectedSelfReq.id,
                              )}
                              onChange={() =>
                                handleCompanyToggle(item, selectedSelfReq.id)
                              }
                            />
                          )}
                        </div>
                      </div>

                      {/* Only show payment details if company is not collapsed */}
                      {/* Payment details with smooth collapse animation */}
                      {/* {listingType === "GREATER_THAN_SEVEN_DAYS" && (
                        <div
                          className={`${Styles.collapseContainer} ${
                            isCollapsed ? Styles.collapsed : Styles.expanded
                          }`}
                        >
                          <div className={Styles.collapseContent}>
                            <div
                              style={{ borderBottom: "0px" }}
                              className={Styles.row}
                            >
                              <div
                                style={{
                                  flexBasis: "200px",
                                  minWidth: "200px",
                                  maxWidth: "200px",
                                  width: "200px",
                                }}
                              >
                                EMD{" "}
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "var(--fourth-color-text)",
                                  }}
                                >
                                  (₹/MW)
                                </span>
                                <Tooltip
                                  title={
                                    <span style={{ whiteSpace: "pre-line" }}>
                                      <strong>Seller’s EMD:</strong> An amount
                                      of ₹30,000 per MW or ₹1,00,000, whichever
                                      is lower, shall be deducted.
                                      <br />
                                      <br />
                                      <strong>Buyer's EMD:</strong> 0
                                    </span>
                                  }
                                >
                                  <IconButton>
                                    <InfoIcon />
                                  </IconButton>
                                </Tooltip>
                              </div>
                              <div style={{ fontWeight: 500 }}>
                                {selfCapacityById?.emd}
                              </div>
                              <div style={{ fontWeight: 500 }}>{item.emd}</div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <input
                                  style={{
                                    border:
                                      isDisabled &&
                                      item.emd !== Number(currentValues.emd)
                                        ? "2px solid var(--primary-color-text)"
                                        : "",
                                  }}
                                  disabled={true}
                                  type="number"
                                  className={Styles.inputBox}
                                  value={currentValues.emd}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      "emd",
                                      item,
                                      matchSlotsCount,
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div
                              style={{ borderBottom: "0px" }}
                              className={Styles.row}
                            >
                              <div
                                style={{
                                  flexBasis: "200px",
                                  minWidth: "200px",
                                  maxWidth: "200px",
                                  width: "200px",
                                }}
                              >
                                Initial Margin{" "}
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "var(--fourth-color-text)",
                                  }}
                                >
                                  (%)
                                </span>
                                <Tooltip
                                  title={
                                    <span style={{ whiteSpace: "pre-line" }}>
                                      <strong>Buyer’s Initial Margin</strong>:
                                      The percentage of the total transaction
                                      value required to be deposited by the
                                      Buyer for a single day.
                                      <br />
                                      <br />
                                      <strong>Seller’s Initial Margin</strong>:
                                      A fixed margin equivalent to 20% of the
                                      total transaction value, to be deposited
                                      by the Seller for a single day.
                                    </span>
                                  }
                                >
                                  <IconButton>
                                    <InfoIcon />
                                  </IconButton>
                                </Tooltip>
                              </div>
                              <div style={{ fontWeight: 500 }}>
                                {selfCapacityById?.initialMargin}
                              </div>
                              <div style={{ fontWeight: 500 }}>
                                {item.initialMargin}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <input
                                  max={200}
                                  min={100}
                                  style={{
                                    border:
                                      isDisabled &&
                                      item.initialMargin !==
                                        Number(currentValues.initialMargin)
                                        ? "2px solid var(--primary-color-text)"
                                        : "",
                                  }}
                                  disabled={
                                    isDisabled ||
                                    isIntraday ||
                                    listingType === "INTRA_DAY" ||
                                    listingType === "NEXT_DAY" ||
                                    listingType === "UPTO_SEVEN_DAYS" ||
                                    listingType === "GREATER_THAN_SEVEN_DAYS"
                                  }
                                  type="number"
                                  className={Styles.inputBox}
                                  value={currentValues.initialMargin}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      "initialMargin",
                                      item,
                                      matchSlotsCount,
                                    )
                                  }
                                />
                              </div>
                            </div>

                            <div className={Styles.row}>
                              <div
                                style={{
                                  flexBasis: "200px",
                                  minWidth: "200px",
                                  maxWidth: "200px",
                                  width: "200px",
                                }}
                              >
                                Payment Security{" "}
                                <span
                                  style={{
                                    fontSize: "10px",
                                    color: "var(--fourth-color-text)",
                                  }}
                                >
                                  (# Days)
                                </span>
                                <Tooltip
                                  title={
                                    <span style={{ whiteSpace: "pre-line" }}>
                                      <strong>Buyer’s Payment Security:</strong>{" "}
                                      Calculated as the Buyer’s Initial Margin
                                      multiplied by the transaction value for
                                      one trading day and the number of days of
                                      payment security.
                                      <br />
                                      <br />
                                      <strong>
                                        Seller’s Payment Security:
                                      </strong>{" "}
                                      Sellers’ initial margin will be considered
                                      as payment security.
                                    </span>
                                  }
                                >
                                  <IconButton>
                                    <InfoIcon />
                                  </IconButton>
                                </Tooltip>
                              </div>
                              <div style={{ fontWeight: 500 }}>
                                {selfCapacityById?.paymentSecurity}
                              </div>
                              <div style={{ fontWeight: 500 }}>
                                {item.paymentSecurity}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <input
                                  style={{
                                    border:
                                      isDisabled &&
                                      item.paymentSecurity !==
                                        Number(currentValues.paymentSecurity)
                                        ? "2px solid var(--primary-color-text)"
                                        : "",
                                  }}
                                  disabled={
                                    isDisabled ||
                                    isIntraday ||
                                    listingType === "UPTO_SEVEN_DAYS" ||
                                    listingType === "GREATER_THAN_SEVEN_DAYS"
                                  }
                                  type="number"
                                  className={Styles.inputBox}
                                  value={currentValues.paymentSecurity}
                                  min={0}
                                  step={1}
                                  onWheel={(e) => e.target.blur()} // Prevent scroll changing value
                                  onKeyDown={(e) => {
                                    // Block decimal input
                                    if (e.key === "." || e.key === "Decimal") {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      "paymentSecurity",
                                      item,
                                      matchSlotsCount,
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )} */}
                    </div>

                    {/* Only show requisitions if company is not collapsed */}
                    <div
                      className={`${Styles.collapseContainer} ${
                        isCollapsed ? Styles.collapsed : Styles.expanded
                      }`}
                    >
                      <div className={Styles.collapseContent}>
                        {item.matchSlots.map((matchSlot, idx) => {
                          const isReqCollapsed = isRequisitionCollapsed(
                            item.bidId,
                            selectedSelfReq.id,
                            matchSlot.id,
                          );

                          const today = new Date();
                          today.setHours(0, 0, 0, 0);
                          const tomorrow = new Date(today);
                          tomorrow.setDate(today.getDate() + 1);
                          const upto7 = new Date(today);
                          upto7.setDate(today.getDate() + 6);
                          // allow greater_7 from today; end date must be >= today + 8
                          const greater7EndMin = new Date(today);
                          greater7EndMin.setDate(today.getDate() + 7);
                          // New: bounds for "Next 7 days" end-date selection
                          const dayAfterTomorrow = new Date(today);
                          dayAfterTomorrow.setDate(today.getDate() + 2);
                          const next7EndMax = new Date(today);
                          next7EndMax.setDate(today.getDate() + 6);
                          const greaterthan7 = new Date(today);
                          greaterthan7.setDate(today.getDate() + 4);
                          const isReqSelected = selectedBids.some(
                            (bid) =>
                              bid.id === matchSlot.id &&
                              bid.selfSlotId ===
                                dataWithIndex[0].matches[selectedSelfReq.id]
                                  .selfSlot.id &&
                              bid.matchIndex === selectedSelfReq.id,
                          );

                          const isReqExpanded = !isReqCollapsed;

                          return (
                            <div
                              className={Styles.reqSection}
                              key={matchSlot.id}
                            >
                              <div
                                style={{
                                  backgroundColor: "#EFFCFF",
                                }}
                                className={Styles.row}
                              >
                                <div
                                  style={{
                                    fontWeight: 500,
                                    fontSize: "12px",
                                    color: "#34656D",
                                    width: "90%",
                                    flex: "0 0",
                                    marginRight: "15px",
                                    textWrap: "nowrap",
                                  }}
                                >
                                  {item.generatorName || item.consumerName} -
                                  Requisition {idx + 1}
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                    flex: "0 0",
                                  }}
                                >
                                  {!isEditTerms && (
                                    <AntSwitch
                                      checked={isReqSelected}
                                      onChange={() =>
                                        handleUserSelectBid(
                                          matchSlot,
                                          item,
                                          selectedSelfReq.id,
                                        )
                                      }
                                    />
                                  )}
                                </div>
                              </div>

                              <div
                                className={`${Styles.reqContent} ${
                                  isReqExpanded
                                    ? Styles.expanded
                                    : Styles.collapsed
                                }`}
                              >
                                <>
                                  <div className={Styles.row}>
                                    <div
                                      style={{
                                        flexBasis: "191px",
                                        minWidth: "191px",
                                        maxWidth: "191px",
                                        width: "191px",
                                      }}
                                    >
                                      Energy Rate{" "}
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          color: "var(--fourth-color-text)",
                                        }}
                                      >
                                        (₹/kWh)
                                      </span>
                                    </div>
                                    <div style={{ fontWeight: 500 }}>
                                      {" "}
                                      {selfSlot.energyRateType === "FIXED"
                                        ? (selfSlot[`sellingCost`] ??
                                          selfSlot[`landingCost`] ??
                                          selfSlot[`energyRate`])
                                        : selfSlot.energyRateType === "DAM_PLUS"
                                          ? `DAM+${
                                              selfSlot[`sellingCost`] ??
                                              selfSlot[`landingCost`] ??
                                              selfSlot[`energyRate`]
                                            }`
                                          : `DAM-${
                                              selfSlot[`sellingCost`] ??
                                              selfSlot[`landingCost`] ??
                                              selfSlot[`energyRate`]
                                            }`}
                                    </div>
                                    <div
                                      style={{ fontWeight: 500 }}
                                      className={Styles.greenText}
                                    >
                                      {matchSlot?.energyRateType === "FIXED"
                                        ? (matchSlot?.sellingCost ??
                                          matchSlot?.landingCost)
                                        : matchSlot?.energyRateType ===
                                            "DAM_PLUS"
                                          ? `DAM+${
                                              matchSlot?.sellingCost ??
                                              matchSlot?.landingCost
                                            }`
                                          : `DAM-${
                                              matchSlot?.sellingCost ??
                                              matchSlot?.landingCost
                                            }`}
                                    </div>
                                    <div style={{ position: "relative" }}>
                                      <input
                                        min={0}
                                        style={{
                                          width: "30%",
                                          paddingLeft: "90px",
                                          border:
                                            isDisabled &&
                                            HighlightIfDifferent({
                                              value: `${
                                                currentValues[
                                                  `req${idx + 1}_energyRateStr`
                                                ] === "FIXED"
                                                  ? currentValues[
                                                      `req${idx + 1}_energyRate`
                                                    ]
                                                  : currentValues[
                                                        `req${
                                                          idx + 1
                                                        }_energyRateStr`
                                                      ] === "DAM_PLUS"
                                                    ? `DAM+${
                                                        currentValues[
                                                          `req${
                                                            idx + 1
                                                          }_energyRate`
                                                        ]
                                                      }`
                                                    : `DAM-${
                                                        currentValues[
                                                          `req${
                                                            idx + 1
                                                          }_energyRate`
                                                        ]
                                                      }`
                                              }`,
                                              compareWith: `${
                                                matchSlot?.energyRateType ===
                                                "FIXED"
                                                  ? (matchSlot?.sellingCost ??
                                                    matchSlot?.landingCost)
                                                  : matchSlot?.energyRateType ===
                                                      "DAM_PLUS"
                                                    ? `DAM+${
                                                        matchSlot?.sellingCost ??
                                                        matchSlot?.landingCost
                                                      }`
                                                    : `DAM-${
                                                        matchSlot?.sellingCost ??
                                                        matchSlot?.landingCost
                                                      }`
                                              }`,
                                            })
                                              ? "2px solid var(--primary-color-text)"
                                              : "",
                                        }}
                                        disabled={isDisabled}
                                        type="number"
                                        className={Styles.inputBox}
                                        value={
                                          currentValues[
                                            `req${idx + 1}_energyRate`
                                          ] ?? ""
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            e,
                                            `req${idx + 1}_energyRate`,
                                            item,
                                            matchSlotsCount,
                                          )
                                        }
                                        placeholder="Enter rate"
                                      />

                                      <div
                                        style={{
                                          position: "absolute",
                                          left: "3px",
                                          top:
                                            isDisabled &&
                                            HighlightIfDifferent({
                                              value: `${
                                                currentValues[
                                                  `req${idx + 1}_energyRateStr`
                                                ] === "FIXED"
                                                  ? currentValues[
                                                      `req${idx + 1}_energyRate`
                                                    ]
                                                  : currentValues[
                                                        `req${
                                                          idx + 1
                                                        }_energyRateStr`
                                                      ] === "DAM_PLUS"
                                                    ? `DAM+${
                                                        currentValues[
                                                          `req${
                                                            idx + 1
                                                          }_energyRate`
                                                        ]
                                                      }`
                                                    : `DAM-${
                                                        currentValues[
                                                          `req${
                                                            idx + 1
                                                          }_energyRate`
                                                        ]
                                                      }`
                                              }`,
                                              compareWith: `${
                                                matchSlot?.energyRateType ===
                                                "FIXED"
                                                  ? (matchSlot?.sellingCost ??
                                                    matchSlot?.landingCost)
                                                  : matchSlot?.energyRateType ===
                                                      "DAM_PLUS"
                                                    ? `DAM+${
                                                        matchSlot?.sellingCost ??
                                                        matchSlot?.landingCost
                                                      }`
                                                    : `DAM-${
                                                        matchSlot?.sellingCost ??
                                                        matchSlot?.landingCost
                                                      }`
                                              }`,
                                            })
                                              ? "9px"
                                              : "8px",
                                        }}
                                      >
                                        <SelectInput
                                          showExample={false}
                                          style={{
                                            width: "85px",
                                            borderRadius: "5px",
                                            border:
                                              "1px solid var(--primary-color-text)",
                                            backgroundColor: "#fffaf6",
                                            color: "var(--primary-color-text)",
                                            padding: "0px",
                                          }}
                                          list={EnergyRateList?.map(
                                            (item) => item.name,
                                          )}
                                          example={"Select Type"}
                                          onChange={(selectedName) => {
                                            // Find the corresponding energy rate type value
                                            const selectedItem =
                                              EnergyRateList.find(
                                                (item) =>
                                                  item.name === selectedName,
                                              );

                                            let energyRateType;
                                            if (
                                              selectedItem?.name === "Fixed"
                                            ) {
                                              energyRateType = "FIXED";
                                            } else if (
                                              selectedItem?.name === "DAM+"
                                            ) {
                                              energyRateType = "DAM_PLUS";
                                            } else if (
                                              selectedItem?.name === "DAM-"
                                            ) {
                                              energyRateType = "DAM_MINUS";
                                            }

                                            // Call the handler to change type for all requisitions
                                            handleEnergyRateTypeChange(
                                              energyRateType,
                                              item,
                                              selectedSelfReq.id,
                                            );
                                          }}
                                          value={
                                            currentValues[
                                              `req${idx + 1}_energyRateStr`
                                            ] === "DAM_PLUS"
                                              ? "DAM+"
                                              : currentValues[
                                                    `req${idx + 1}_energyRateStr`
                                                  ] === "DAM_MINUS"
                                                ? "DAM-"
                                                : "Fixed"
                                          }
                                          height={24}
                                          disabled={isDisabled}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className={Styles.row}>
                                    <div
                                      style={{
                                        flexBasis: "191px",
                                        minWidth: "191px",
                                        maxWidth: "191px",
                                        width: "191px",
                                      }}
                                    >
                                      Quantity{" "}
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          color: "var(--fourth-color-text)",
                                        }}
                                      >
                                        (MW)
                                      </span>
                                    </div>
                                    <div style={{ fontWeight: 500 }}>
                                      {selfSlot[`sellEnergy`] ||
                                        selfSlot[`purchaseEnergy`] ||
                                        selfSlot[`quantity`]}{" "}
                                    </div>
                                    <div
                                      style={{ fontWeight: 500 }}
                                      className={Styles.greenText}
                                    >
                                      {matchSlot.sellEnergy ||
                                        matchSlot.purchaseEnergy}{" "}
                                    </div>
                                    <div>
                                      <input
                                        style={{
                                          border:
                                            isDisabled &&
                                            (matchSlot.sellEnergy ||
                                              matchSlot.purchaseEnergy) !==
                                              Number(
                                                currentValues[
                                                  `req${idx + 1}_quantity`
                                                ],
                                              )
                                              ? "2px solid var(--primary-color-text)"
                                              : "",
                                        }}
                                        min={0}
                                        max={getMaxQuantity()}
                                        disabled={isDisabled}
                                        type="number"
                                        className={Styles.inputBox}
                                        value={
                                          currentValues[
                                            `req${idx + 1}_quantity`
                                          ]
                                        }
                                        onChange={(e) =>
                                          handleInputChange(
                                            e,
                                            `req${idx + 1}_quantity`,
                                            item,
                                            matchSlotsCount,
                                          )
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className={Styles.row}>
                                    <div
                                      style={{
                                        flexBasis: "191px",
                                        minWidth: "191px",
                                        maxWidth: "191px",
                                        width: "191px",
                                      }}
                                    >
                                      Start Date
                                    </div>
                                    <div>
                                      {formatDate(selfSlot[`dateStartAt`])}
                                    </div>
                                    <div>
                                      {formatDate(matchSlot.dateStartAt)}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                      }}
                                    >
                                      <DateInput
                                        usePortal={true}
                                        style={{
                                          width: "94%",
                                          paddingLeft: "15px",
                                          border:
                                            isDisabled &&
                                            matchSlot.dateStartAt !==
                                              currentValues[
                                                `req${idx + 1}_startDate`
                                              ]
                                              ? "2px solid var(--primary-color-text)"
                                              : "",
                                        }}
                                        value={
                                          currentValues[
                                            `req${idx + 1}_startDate`
                                          ] || ""
                                        }
                                        disabled={
                                          isDisabled ||
                                          isIntraday ||
                                          listingType === "INTRA_DAY" ||
                                          listingType === "NEXT_DAY"
                                        }
                                        onChange={(e) => {
                                          return handleInputChange(
                                            e,
                                            `req${idx + 1}_startDate`,
                                            item,
                                            matchSlotsCount,
                                          );
                                        }}
                                        minDate={
                                          listingType === "INTRA_DAY"
                                            ? today
                                            : listingType === "NEXT_DAY"
                                              ? tomorrow
                                              : listingType ===
                                                  "UPTO_SEVEN_DAYS"
                                                ? today
                                                : listingType ===
                                                    "GREATER_THAN_SEVEN_DAYS"
                                                  ? greaterthan7
                                                  : new Date()
                                        }
                                        maxDate={
                                          listingType === "INTRA_DAY"
                                            ? today
                                            : listingType === "NEXT_DAY"
                                              ? tomorrow
                                              : listingType ===
                                                  "UPTO_SEVEN_DAYS"
                                                ? upto7
                                                : undefined
                                        }
                                        height={32}
                                      />
                                    </div>
                                  </div>
                                  <div className={Styles.row}>
                                    <div
                                      style={{
                                        flexBasis: "191px",
                                        minWidth: "191px",
                                        maxWidth: "191px",
                                        width: "191px",
                                      }}
                                    >
                                      End Date
                                    </div>
                                    <div>
                                      {formatDate(selfSlot[`dateEndAt`])}
                                    </div>
                                    <div>{formatDate(matchSlot.dateEndAt)}</div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                      }}
                                    >
                                      <DateInput
                                        value={
                                          currentValues[
                                            `req${idx + 1}_endDate`
                                          ] || ""
                                        }
                                        usePortal={true}
                                        style={{
                                          width: "94%",
                                          paddingLeft: "15px",
                                          border:
                                            isDisabled &&
                                            matchSlot.dateEndAt !==
                                              currentValues[
                                                `req${idx + 1}_endDate`
                                              ]
                                              ? "2px solid var(--primary-color-text)"
                                              : "",
                                        }}
                                        disabled={
                                          isDisabled ||
                                          isIntraday ||
                                          listingType === "INTRA_DAY" ||
                                          listingType === "NEXT_DAY"
                                        }
                                        minDate={
                                          listingType === "INTRA_DAY"
                                            ? today
                                            : listingType === "NEXT_DAY"
                                              ? tomorrow
                                              : listingType ===
                                                  "UPTO_SEVEN_DAYS"
                                                ? dayAfterTomorrow
                                                : listingType ===
                                                    "GREATER_THAN_SEVEN_DAYS"
                                                  ? greaterthan7
                                                  : matchSlot[idx]?.startDate
                                        }
                                        maxDate={
                                          listingType === "INTRA_DAY"
                                            ? today
                                            : listingType === "NEXT_DAY"
                                              ? tomorrow
                                              : listingType ===
                                                  "UPTO_SEVEN_DAYS"
                                                ? next7EndMax
                                                : undefined
                                        }
                                        onChange={(e) => {
                                          return handleInputChange(
                                            e,
                                            `req${idx + 1}_endDate`,
                                            item,
                                            matchSlotsCount,
                                          );
                                        }}
                                        height={32}
                                      />
                                    </div>
                                  </div>
                                  <div className={Styles.row}>
                                    <div
                                      style={{
                                        flexBasis: "191px",
                                        minWidth: "191px",
                                        maxWidth: "191px",
                                        width: "191px",
                                      }}
                                    >
                                      Start Time
                                    </div>
                                    <div>
                                      {formatSlotTime(selfSlot[`slotStartAt`])}
                                    </div>
                                    <div>
                                      {formatSlotTime(matchSlot.slotStartAt)}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                      }}
                                    >
                                      <TimeInput
                                        style={{
                                          width: "98%",
                                          border:
                                            isDisabled &&
                                            String(
                                              formatSlotTime(
                                                matchSlot.slotStartAt,
                                              ),
                                            ) !==
                                              String(
                                                formatSlotTime(
                                                  currentValues[
                                                    `req${idx + 1}_startTime`
                                                  ],
                                                ),
                                              )
                                              ? "2px solid var(--primary-color-text)"
                                              : "",
                                        }}
                                        noTooltip={true}
                                        value={
                                          formatSlotTime(
                                            currentValues[
                                              `req${idx + 1}_startTime`
                                            ],
                                          ) || ""
                                        }
                                        disabled={isDisabled}
                                        onChange={(val) =>
                                          handleInputChange(
                                            { target: { value: val } },
                                            `req${idx + 1}_startTime`,
                                            item,
                                            matchSlotsCount,
                                          )
                                        }
                                        height={32}
                                        type="startTime"
                                      />
                                    </div>
                                  </div>
                                  <div className={Styles.row}>
                                    <div
                                      style={{
                                        flexBasis: "191px",
                                        minWidth: "191px",
                                        maxWidth: "191px",
                                        width: "191px",
                                      }}
                                    >
                                      End Time
                                    </div>
                                    <div>
                                      {formatSlotTime(selfSlot[`slotEndAt`])}
                                    </div>
                                    <div>
                                      {formatSlotTime(matchSlot.slotEndAt)}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "end",
                                      }}
                                    >
                                      <TimeInput
                                        style={{
                                          width: "98%",
                                          border:
                                            isDisabled &&
                                            String(
                                              formatSlotTime(
                                                matchSlot.slotEndAt,
                                              ),
                                            ) !==
                                              String(
                                                formatSlotTime(
                                                  currentValues[
                                                    `req${idx + 1}_endTime`
                                                  ],
                                                ),
                                              )
                                              ? "2px solid var(--primary-color-text)"
                                              : "",
                                        }}
                                        value={
                                          formatSlotTime(
                                            currentValues[
                                              `req${idx + 1}_endTime`
                                            ],
                                          ) || ""
                                        }
                                        disabled={isDisabled}
                                        onChange={(val) =>
                                          handleInputChange(
                                            { target: { value: val } },
                                            `req${idx + 1}_endTime`,
                                            item,
                                            matchSlotsCount,
                                          )
                                        }
                                        height={32}
                                        type="endTime"
                                        startTime={
                                          currentValues[
                                            `req${idx + 1}_startTime`
                                          ] || ""
                                        }
                                      />
                                    </div>
                                  </div>
                                </>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              padding: "7px 25px",
            }}
          >
            <div
              style={{
                display: "flex",

                gap: "16px",
              }}
            >
              <button
                style={{
                  padding: "12px 24px",
                  border: "none",
                  background: "var(--disabled-color-background)",
                  color: "#808080ff",
                  borderRadius: "6px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleClose();
                }}
              >
                Cancel
              </button>

              {type === "accept" && (
                <button
                  style={{
                    padding: "12px 24px",
                    backgroundColor:
                      "var(--warning-background-thin) !important",
                    color: "var(--danger-shade-text)",
                    border: "1px solid var(--danger-shade-text)",
                    borderRadius: "6px",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setRejectContract({
                      contractIds: mainScreenMatchData?.map((ele) => ({
                        contractId: ele?.id,
                        consumerId: ele?.capacityConsumer?.consumerId,
                        consumerName: ele?.capacityConsumer?.consumerName,
                        generatorId: ele?.capacityGenerator?.generatorId,
                        generatorName: ele?.capacityGenerator?.generatorName,
                      })),
                    });
                    setRejectAllTermsConfirm(true);
                  }}
                >
                  Reject All
                </button>
              )}

              <button
                disabled={loading}
                style={{
                  padding: "12px 24px",
                  border: "none",
                  background: "var(--primary-color-text)",
                  color: "#fff",
                  borderRadius: "6px",
                  fontWeight: 500,
                  cursor: loading ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  const filledValues = getAllFilledFinalValues();
                  if (!filledValues) return;
                  if (selectedBids.length === 0) {
                    toast.error("Please select at least one requestion.");
                    return;
                  }

                  setChargeDetails({
                    contractIds: mainScreenMatchData?.map((ele) => {
                      return {
                        contractId: ele?.id,
                        consumerId: ele?.capacityConsumer?.consumerId,
                        consumerName: ele?.capacityConsumer?.consumerName,
                        generatorId: ele?.capacityGenerator?.generatorId,
                        generatorName: ele?.capacityGenerator?.generatorName,
                      };
                    }),
                    selfId: selfEntityId,
                    counterIds: selectedBids?.map((ele) => {
                      return {
                        counterName: ele?.company,
                        counterId: ele?.counterpartyEntityId,
                        name: ele?.name,
                      };
                    }),
                  });
                  setChargeModal(true);
                }}
              >
                {loading
                  ? "Submitting..."
                  : type === "accept"
                    ? "Continue"
                    : "Continue"}
              </button>

              <ConfirmationModal
                open={conformOpen}
                loading={loading}
                handleClose={() => setConformOpen(false)}
                handleSubmit={(val) => {
                  const filledValues = getAllFilledFinalValues();
                  console.log(
                    "🚀 ~ TermsCondition ~ filledValues:",
                    filledValues,
                  );
                  if (!filledValues) return; // stop if validation failed
                  // When editing, pass an edit flag to the submit handler (optional)
                  if (isEditTerms) {
                    handleTermsSubmit(filledValues, { isEdit: true });
                  } else {
                    handleChargeFinal(filledValues, val);
                  }
                }}
                header={
                  type === "accept"
                    ? "Approve Terms Confirmation"
                    : isEditTerms
                      ? "Update Terms Confirmation"
                      : "Finalize Terms Confirmation"
                }
                data={
                  type === "accept" ? (
                    <>
                      Once the Terms & Conditions are accepted, no further
                      changes will be allowed.{" "}
                      <b>Initial Margin will be blocked.</b> Do you want to
                      continue?
                    </>
                  ) : isEditTerms ? (
                    "You are about to update previously finalized T&C. This will overwrite existing finalized values. Do you want to continue?"
                  ) : (
                    "The T&C will be shared with the counterparty for final approval. All other pending connection requests will be auto-rejected. Do you want to continue?"
                  )
                }
              />

              <ConfirmationModal
                open={rejectAllTermsConfirm}
                handleClose={() => setRejectAllTermsConfirm(false)}
                handleSubmit={(e) => {
                  handleDirectTermsSumbit(
                    rejectContract?.contractIds,
                    "REJECTED",
                  );
                  handleRejectAllTermsSubmit(e);
                }}
                header={"Confirm Rejection of Terms"}
                data={
                  "Declining will cancel this transaction. Do you want to continue?"
                }
                loading={rejectLoading}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TermsCondition;
